
import Color from 'color';
import { $S } from '../utils/dp-utils';
import DPBoundingBox from './DPBoundingBox';
import classNames from 'classnames';
import BulletsAnimation from '../../../../includes/assets/js/modules/BulletsAnimation';


const ee = require('event-emitter');
const { normal } = require('color-blend');


const colorToRgbaObject = (color) => {
	return {
		r: color.red(),
		g: color.green(),
		b: color.blue(),
		a: color.alpha()
	};
};

const rgbaObjectToColor = (rgba) => {
	const res = Color.rgb(rgba.r, rgba.g, rgba.b);
	res.alpha(rgba.a);
	return res;
};

export const LAYER_CLASSES = {
	main: 'dpintro-main',
	highlight: 'dpintro-highlight',
	tooltipReference: 'dpintro-tooltip-ref',
	tooltip: 'dpintro-tooltip',
	tooltipText: 'dpintro-tooltip-text',
	arrow: 'dpintro-arrow',
	progress: 'dpintro-progress',
	progressBar: 'dpintro-progress-bar',
	tooltipButtons: 'dpintro-tooltip-buttons',
	bullets: 'dpintro-bullets',
	tooltipNumber: 'dpintro-tooltip-number',
	button: 'dpintro-button',
	buttonNext: 'dpintro-button--next',
	buttonPrev: 'dpintro-button--prev',
	buttonSkip: 'dpintro-button--skip',
	buttonFull: 'dpintro-button--full',
	buttonDone: 'dpintro-button--done',
	overlay: 'dpintro-overlay',
	overlayBlurredModifier: '--blurred',
	overlayContainer: 'dpintro-overlay-container',
	disableInteraction: 'dpintro-disable-interaction',
	hidden: 'dpintro-hidden',
	hiddenByOpacity: 'dpintro-hidden-by-opacity',
	disabled: 'dpintro-disabled'
};

export const EVENTS = {
	onBeforeChange: 'onBeforeChange',
	onStarted: 'onStarted',
	onChange: 'onChange',
	onAfterChange: 'onAfterChange',
	onComplete: 'onComplete',
	onExit: 'onExit',
	onSkip: 'onSkip',
	onBeforeExit: 'onBeforeExit',
	onLayersInit: 'onLayersInit',
	onButtonHover: 'onButtonHover',
	onResize: 'onResize'
};

export const CALLBACKS = {
	onBeforeChange: 'onBeforeChange',
	onBeforeShowStep: 'onBeforeShowStep',
	onBeforeExit: 'onBeforeExit'
};

const LAYER_OPACITY_TRANSITION_MS = 300;


export default class DPIntroCore {
	constructor(mainElement, dpDebugEn) {
		this.VERSION = '1.0.1';
		if (dpDebugEn) console.log('DPIntroCore ' + this.VERSION);
		//console.log('DEV DBG');
		this._mainElement = mainElement;
		const jWrapperEl = $(this._mainElement).closest('.dpintro-wrapper');
		this._wrapperEl = jWrapperEl.length ? jWrapperEl[0] : null;
		this._introItems = [];
		this._activeControl = 'next';
		this._lastShownItem = null;
		this.document_width = $('body').innerWidth();
		this.document_height = $(document).height();
		this.isFollowTargetPositionEnabled = true;
		this.emitter = ee();
		this._movingTime = parseInt(this._getCssVarVal(this._wrapperEl, '--moving-transition-time-ms', 300)) + 80;
		this._options = {
			dpDebugEn: dpDebugEn,
			/* Next button label in tooltip box */
			nextLabel: 'Next &rarr;', // &rarr
			/* Previous button label in tooltip box */
			prevLabel: '&larr; Back',
			/* Skip button label in tooltip box */
			skipLabel: 'Skip',
			/* Done button label in tooltip box */
			doneLabel: 'Done',
			/* Hide previous button always. */
			hide_previous_step_button: false,
			/* Disable navigation to step by click to bullet. */
			disable_navigation_by_bullets: false,
			/* Hide next button always. */
			hideNextAlways: false,
			/* Hide previous button in the first step? Otherwise, it will be disabled button. */
			hidePrev: true,
			/* Hide next button in the last step? Otherwise, it will be disabled button. */
			hideNext: true,
			/* Hide skip button if it is not DONE - in the last step? */
			hide_skip_button: false,
			/* Default tooltip box position */
			tooltipPosition: 'bottom',
			/* Next CSS class for tooltip boxes */
			tooltipClass: '',
			/* CSS class that is added to the helperLayer */
			highlightClass: '',
			/* Close introduction when pressing Escape button? */
			exitOnEsc: true,
			/* Close introduction when clicking on overlay layer? */
			exitOnOverlayClick: true,
			/* Show step numbers in introduction? */
			showStepNumbers: true,
			/* Let user use keyboard to navigate the tour? */
			keyboardNavigation: true,
			/* Show tour control buttons? */
			showButtons: true,
			/* Show tour bullets? */
			showBullets: true,
			/* Show tour progress? */
			showProgress: false,
			/* Scroll to highlighted element? */
			scrollToElement: true,
			/* Distance of tooltip ... resp tooltip arrow from highlited box on targeted element */
			tooltipDistanceFromTarget: 3,

			tooltipMinMarginX: 10,

			arrowAlignNormCoef: 0.07,
			//Should we scroll the tooltip target element or both?  Options are: 'element', 'tooltip' or all
			scrollTo: 'all',
			/* Padding to add after scrolling when element is not in the viewport (in pixels) */
			scrollPadding: 30,
			/* Set the overlay opacity */
			overlayOpacity: 0.8,
			overlayOpacityCoefWhenScroll: 0.6,

			overlayBlurred: false,
			/* Precedence of positions, when auto is enabled */
			positionPrecedence: ['bottom', 'top', 'right', 'left', 'center'],
			/* Disable an interaction with element? */
			enable_interaction: '1',
			/* Set how much padding to be used around helper element */
			helperElementPadding: 15,
			/* Default hint position */
			hintPosition: 'top-middle',
			/* Hint button label */
			hintButtonLabel: 'Got it',
			/* Adding animation to hints? */
			hintAnimation: true,

			/* additional classes to put on the buttons */
			buttonClass: LAYER_CLASSES.button,

			controlsAutoFocusEnable: true,

			centerTopBottomPosOffset: 80,

			scrollSpeedPerPageMs: 300,
			maxScrollSpeedPerPageMs: 550,
			disableDelayedAfterCheckPosition: false,

			max_tooltip_width: 0,

			leave_overlay_always: false,

			customTextStylesEn: true,
			scrollEasing: 'swing',
			scrollDurationMsOverride: -1
		};

		jQuery.fn.onOffsetOrDimensionChanged = function (trigger, insensitivity = 2, ms = 150) {
			ms ??= 10;
			let o = $(this[0]); // our jquery object
			if (o.length < 1) return o;

			let lastOff = null;
			let lastWidth = null;
			let lastHeight = null;
			o.interval = setInterval(function () {
				if (o == null || o.length < 1) return o; // abort if element is non existend eny more
				if (!o.hasClass('dpintro-show-element')) clearInterval(o.interval);

				lastOff ??= o.offset();
				lastWidth ??= o.width();
				lastHeight ??= o.height();

				let newOff = o.offset();
				let newWidth = o.width();
				let newHeight = o.height();


				if (Math.abs(lastOff.top - newOff.top) > insensitivity
					|| Math.abs(lastOff.left - newOff.left) > insensitivity
					|| Math.abs(lastWidth - newWidth) > insensitivity
					|| Math.abs(lastHeight - newHeight) > insensitivity
				) {
					$(this).trigger('onOffsetOrDimensionChanged', {
						source: o[0],
						lastOff: lastOff,
						newOff: newOff,
						lastWidth: lastWidth,
						newWidth: newWidth,
						lastHeight: lastHeight,
						newHeight: newHeight,
					});
					if (typeof (trigger) == 'function') trigger(o[0], lastOff, newOff, lastWidth, newWidth, lastHeight, newHeight);
					lastOff = newOff;
					lastWidth = newWidth;
					lastHeight = newHeight;
				}
			}, ms);

			return o;
		};

	}

	_getCssVarVal = (layer, variableName, def = null) => {
		let res = def;
		if (layer && variableName) {
			const tmp = getComputedStyle(layer).getPropertyValue(variableName);
			if (tmp !== null && tmp !== undefined && tmp !== '') {
				res = tmp;
			}
		}
		return res;
	}

	isFixedTooltipBottomTheme = () => {
		let res = false;
		if (this._wrapperEl) {
			res = $(this._wrapperEl).hasClass('fancybar');
		}
		return res;
	}


	setStepAsDummy = (step) => {
		if (step) {
			this.dummyElement = this._mainElement.querySelector('.dpintro-dummyelement');
			step.isDummyElement = true;
			if (this.dummyElement === null) {
				this.dummyElement = document.createElement('div');
				this._mainElement.appendChild(this.dummyElement);
			}
			this.dummyElement.className = 'dpintro-dummyelement';

			step.element = this.dummyElement;
		}
	}

	resetStepAsDummy = (step) => {
		if (step && step.isDummyElement) {
			step.isDummyElement = false;
		}
	}

	initSteps() {
		var introItems = [];
		if (this._options.steps) {

			this._forEach(this._options.steps, (step) => {
				var currentItem = this._cloneObject(step);

				//set the step
				currentItem.step = introItems.length + 1;

				//use querySelector function only when developer used CSS selector
				currentItem.selector = currentItem.element;

				this._actualizeStepElement(currentItem, false);

				currentItem.scrollTo = currentItem.scrollTo || this._options.scrollTo;

				if (typeof (currentItem.enable_interaction) === 'undefined') {
					currentItem.enable_interaction = { val: this._options.enable_interaction };
				}

				if (currentItem.element !== null) {
					introItems.push(currentItem);
				}
			});
			this._showIntroElements();
		}

		//removing undefined/null elements
		var tempIntroItems = [];
		for (var z = 0; z < introItems.length; z++) {
			if (introItems[z]) {
				// copy non-falsy values to the end of the array
				tempIntroItems.push(introItems[z]);
			}
		}

		introItems = tempIntroItems;
		//Ok, sort all items with given steps
		introItems.sort((a, b) => {
			return a.step - b.step;
		});
		return introItems;

	}

	/**
	* Start a new intro tour
	*
	* @api private
	* @method start
	* @returns {Boolean} Success or not?
	*/
	start = (startStep = 0, backward = false) => {
		this.ending = false;

		//set it to the DPIntroCore object
		this._introItems = this.initSteps();
		this._currentStep = Math.max(-1, Math.min(startStep - 1, this._introItems.length - 1));

		this.emitter.emit(EVENTS.onStarted, this);

		//add overlay layer to the page
		if (this.addOverlayLayer(false, this._options.overlayBlurred)) {
			//then, start the show
			this.nextStep(backward, true);
			$(this.overlayLayer).on('click', this._onOverlayClick);
			this._onKeyDownEventHandler = this._onKeyDown.bind(this);
			$(window).on('keydown', this._onKeyDownEventHandler);
			//for window resize
			$(window).on('resize', this._onResize);
		}
		return false;
	}

	_onOverlayClick = () => {
		if (this._options.exitOnOverlayClick === true) {
			this._exitIntro('skip');
		}
	}

	setOption = (option, value) => {
		this._options[option] = value;
	}

	setOptions(options) {
		this._options = {
			...this._options,
			...options
		};
	}

	/**
	* Go to specific step of introduction
	*
	* @api private
	* @method goToStep
	*/
	goToStep = (step) => {
		//because steps starts with zero
		const backward = (step - 2) < this._currentStep;
		this._currentStep = step - 2;
		if (typeof (this._introItems) !== 'undefined') {
			this.nextStep(backward);
		}
	}

	/**
	 * Go to the specific step of introduction with the explicit [data-step] number
	 *
	 * @api private
	 * @method goToStepNumber
	 */
	goToStepNumber = (step) => {
		this._currentStepNumber = step;
		if (typeof (this._introItems) !== 'undefined') {
			this.nextStep();
		}
	}

	/**
	 * Go to next step on intro
	 *
	 * @api private
	 * @method nextStep
	 */
	nextStep = (backward = false, isJustStartedStep = false) => {

		if (typeof (this._currentStepNumber) !== 'undefined') {
			this._forEach(this._introItems, (item, i) => {
				if (item.step === this._currentStepNumber) {
					this._currentStep = i - 1;
					this._currentStepNumber = undefined;
				}
			});
		}

		let previousStep = isJustStartedStep ? null : this._introItems[this._currentStep];
		if (previousStep) this.updateIterateAfterClick(previousStep, true);

		if (typeof (this._currentStep) === 'undefined') {
			this._currentStep = 0;
		} else {
			++this._currentStep;
		}

		var nextStep = this._introItems[this._currentStep];
		var continueStep = true;



		this.emitter.emit(EVENTS.onBeforeChange, this, nextStep, backward, previousStep);
		if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
			continueStep = this._introBeforeChangeCallback(this, nextStep, backward, previousStep);
		}

		if (continueStep === -1) {
			--this._currentStep;
			return false;
		}
		else if (continueStep === 0) {
			this.nextStep();
			return;
		}

		if ((this._introItems.length) <= this._currentStep) {
			//end of the intro
			//check if any callback is defined
			this.nextStepOnLastStep();
			return;
		}
		this._activeControl = backward ? 'back' : 'next';
		this._showElement(nextStep, false, false, backward);
	}

	nextStepOnLastStep() {
		this._exitIntro('complete');
		return;
	}

	/**
	 * Go to previous step on intro
	 *
	 * @api private
	 * @method previousStep
	 */
	previousStep = () => {


		if (this._currentStep === 0) {
			return false;
		}
		this._activeControl = 'back';

		let previousStep = this._introItems[this._currentStep];
		if (previousStep) this.updateIterateAfterClick(previousStep, true);

		--this._currentStep;

		var nextStep = this._introItems[this._currentStep];
		var continueStep = true;

		this.emitter.emit(EVENTS.onBeforeChange, this, nextStep, true, previousStep);
		if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
			continueStep = this._introBeforeChangeCallback(this, nextStep, true, previousStep);
		}

		if (continueStep === -1) {
			++this._currentStep;
			return false;
		}
		else if (continueStep === 0) {
			this.previousStep();
			return;
		}

		this._showElement(nextStep, false, false, true);
	}


	/**
	 * Update placement of the intro objects on the screen
	 * @api private
	 */
	refresh = () => {

		if (this._currentStep !== undefined && this._currentStep !== null && this._introItems[this._currentStep]) {
			this._showElement(this._introItems[this._currentStep], true);
		}

		return this;
	}


	_hideIntroElements = (leaveActiveOverlay = false,) => {
		this.isFollowTargetPositionEnabled = false;
		if (!leaveActiveOverlay) this._hideIntroOverlay();
		this._hideLayerByOpacity(this.highlightLayer, LAYER_OPACITY_TRANSITION_MS);
		this._hideLayerByOpacity(this.tooltipReferenceLayer, LAYER_OPACITY_TRANSITION_MS);
		$(this.tooltipLayer).fadeOut(LAYER_OPACITY_TRANSITION_MS);
		this._hideLayerByOpacity(this.tooltipNumberLayer, LAYER_OPACITY_TRANSITION_MS);

		$(this.disableInteractionLayer).fadeOut(LAYER_OPACITY_TRANSITION_MS);
	}

	_showIntroElements = (leaveHidedOverlay = false) => {
		if (!leaveHidedOverlay) this._showIntroOverlay();
		this._showLayerByOpacity(this.highlightLayer);
		this._showLayerByOpacity(this.tooltipReferenceLayer);
		$(this.tooltipLayer).fadeIn(LAYER_OPACITY_TRANSITION_MS);
		this._showLayerByOpacity(this.tooltipNumberLayer);
		$(this.disableInteractionLayer).fadeIn(LAYER_OPACITY_TRANSITION_MS);
		this.isFollowTargetPositionEnabled = true;
	}

	_hideIntroOverlay = () => {
		$(this.overlayLayer).css('opacity', 0);
		setTimeout(() => {
			$(this.overlayContainer).hide();
		}, 450);
	}

	bringIntroOverlayUp = () => {
		$(this.overlayLayer).css('opacity', 0);
		setTimeout(() => {
			$(this.overlayContainer).css('z-index', 100000001);
			$(this.overlayLayer).css('opacity', this._options.overlayOpacity);
		}, 450);
	}

	_showIntroOverlay = () => {
		$(this.overlayContainer).show();
		$(this.overlayLayer).css('opacity', this._options.overlayOpacity);
	}

	_hideLayerByOpacity = (layer, transitionTimeMs = 300) => {
		if (layer) {
			layer.style.opacity = 0;
			setTimeout(() => {
				$(layer).hide();
			}, transitionTimeMs);
		}
	}

	_showLayerByOpacity = (layer) => {
		if (layer) {
			$(layer).show();
			layer.style.opacity = 1;
		}
	}

	_exitIntro(reason) {
		this.exitIntro(false, false, reason);
	}

	/**
	 * Exit from intro
	 *
	 * @api private
	 * @method exitIntro
	 * @param {Object} targetElement
	 * @param {Boolean} force - Setting to `true` will skip the result of beforeExit callback
	 */
	exitIntro = (leaveActiveOverlay = false, force = false, reason = '') => {
		this.ending = true;
		var continueExit = true;

		if (this._options.leave_overlay_always) leaveActiveOverlay = true;

		this.emitter.emit(EVENTS.onBeforeExit, this, reason);
		// calling onbeforeexit callback
		// If this callback return `false`, it would halt the process
		if (this._introBeforeExitCallback !== undefined) {
			continueExit = this._introBeforeExitCallback(this);
		}


		// skip this check if `force` parameter is `true`
		// otherwise, if `onbeforeexit` returned `false`, don't exit the intro
		if (!force && continueExit === false) return;

		this._hideIntroElements(leaveActiveOverlay);
		setTimeout(() => {
			switch (reason) {
				case 'skip': this.emitter.emit(EVENTS.onSkip, this); break;
				case 'complete': this.emitter.emit(EVENTS.onComplete, this); break;
			}
			//remove disableInteractionLayer
			this._enableInteraction(true);
			//remove intro center element
			if (this.dummyElement) {
				this.dummyElement.parentNode.removeChild(this.dummyElement);
				this.dummyElement = null;
			}
			this._clearCurrentStepElement();

			//clean listeners
			if (this._onKeyDownEventHandler)
				$(window).off('keydown', this._onKeyDownEventHandler);
			$(window).off('resize', this._onResize);
			$(this.overlayLayer).off('click', this._onOverlayClick);


			//check if any callback is defined
			this.emitter.emit(EVENTS.onExit, this, reason);

			//set the step to zero
			this._currentStep = undefined;
			this._lastShownItem = undefined;

		}, 500);

	}

	_restoreCurrentStepElement = () => {

		this._setShowElement(this._introItems[this._currentStep].element);
		this._clearContrastAdjustment();
		if (this._lastShowElementBgTimer) window.clearTimeout(this._lastShowElementBgTimer);
		this._fixTargetLowContrast(this.highlightLayer, this._introItems[this._currentStep].element);
	}

	_clearCurrentStepElement = () => {
		this._removeShowElement();
		this._clearContrastAdjustment();
	}

	_pauseTour = () => {
		this._enableInteraction();
		this._clearCurrentStepElement();
		this._hideIntroElements();
	}

	_restoreTour = () => {
		this._disableInteraction();
		this._restoreCurrentStepElement();
		this._showIntroElements();
	}

	subscribeEvent(eventId, providedCallback) {
		if (typeof (providedCallback) === 'function') {
			if (eventId in EVENTS) {
				this.emitter.on(eventId, providedCallback);
			}
			else {
				throw new Error(`Provided event name ${eventId} was not recognized. Choose from: ${EVENTS.values().join(',')}`);
			}
		}
		else {
			throw new Error(`Provided callback for ${eventId} was not a function.`);
		}
	}

	unsubscribeEvent = (eventId, providedCallback) => {
		if (typeof (providedCallback) === 'function') {
			if (eventId in EVENTS) {
				this.emitter.off(eventId, providedCallback);
			}
			else {
				throw new Error(`Provided event name ${eventId} was not recognized. Choose from: ${EVENTS.values().join(',')}`);
			}
		}
		else {
			throw new Error(`Provided callback for ${eventId} was not a function.`);
		}
	}

	setCallback = (callbackId, providedCallback) => {
		if (typeof (providedCallback) === 'function') {
			switch (callbackId) {
				case CALLBACKS.onBeforeChange: this._introBeforeChangeCallback = providedCallback; break;
				case CALLBACKS.onBeforeShowStep: this._introBeforeShowStepCallback = providedCallback; break;
				case CALLBACKS.onBeforeExit: this._introBeforeExitCallback = providedCallback; break;
				default: throw new Error(`Provided callback name ${callbackId} was not recognized.`);
			}
		}
		else {
			throw new Error(`Provided callback for ${callbackId} was not a function.`);
		}
	}


	activateBullet(referenceLayer, rootClass, idx) {
		$(`.${rootClass} li > div.active`).removeClass('active');
		$(`.${rootClass} li > div[data-stepnumber="${idx}"]`).addClass('active');
	}

	setNotVisibleRefBullet(rootClass, idx, notVisible = true) {
		if (notVisible) $(`.${rootClass} li > div[data-stepnumber="${idx}"]`).addClass('not-visible-ref');
		else $(`.${rootClass} li > div[data-stepnumber="${idx}"]`).removeClass('not-visible-ref');
	}

	getNotVisibleStepCnt(rootClass) {
		return $(`.${rootClass} li > div.not-visible-ref`).length;
	}

	createBullet = (step, roleLinkList = true, isActive = false, onClickCallback = null) => {
		var innerLi = document.createElement('li');
		var anchorLink = document.createElement('div');

		if (roleLinkList) {
			innerLi.setAttribute('role', 'presentation');
			anchorLink.setAttribute('role', 'tab');
		}

		if (onClickCallback) anchorLink.onclick = onClickCallback;

		if (isActive) {
			anchorLink.className = 'active';
		}

		if (roleLinkList) {
			this._setAnchorAsButton(anchorLink);
			anchorLink.innerHTML = '&nbsp;';
			anchorLink.setAttribute('data-stepnumber', step);
		}

		innerLi.appendChild(anchorLink);
		return innerLi;
	}

	createBullets = (className = LAYER_CLASSES.bullets, showBullets = false, roleLinkList = true, activeIdx = 0, onClickCallback = null) => {
		const bulletsLayer = document.createElement('div');
		$(bulletsLayer).addClass(className);

		var ulContainer = document.createElement('ul');
		if (roleLinkList) ulContainer.setAttribute('role', 'tablist');

		this._forEach(this._introItems, (item, i) => {
			ulContainer.appendChild(this.createBullet(item.step, roleLinkList, i === activeIdx, onClickCallback));
		});

		bulletsLayer.appendChild(ulContainer);
		if (!showBullets) $(bulletsLayer).fadeOut();
		return bulletsLayer;
	}

	_onResize = (e) => {
		// android chrome status bar trigger resize on scroll fix
		const sizes = {
			oldWidth: this.document_width,
			currentWidth: $('body').innerWidth(),
			oldHeight: this.document_height,
			currentHeight: $(document).height()
		};


		if (sizes.oldWidth != sizes.currentWidth || sizes.oldHeight != sizes.currentHeight) {

			this.document_width = sizes.currentWidth;
			this.document_height = sizes.currentHeight;

			if (!this._resizeTimeout) {
				this._resizeTimeout = setTimeout(() => {
					clearTimeout(this._resizeTimeout);
					this._resizeTimeout = null;

					const tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipTextLayer, false, true);
					// iframe inside tooltip - fullscreen
					if (!(this._isIframeInTooltip && tooltipBB.width !== this.tooltipBBRel.width)) {
						if (this._options.dpDebugEn) console.log('Resize:', sizes);
						this.emitter.emit(EVENTS.onResize, sizes);
						this.refresh();
					}
					this.tooltipBBRel = tooltipBB;
				}, 50);
			}
		}
	}

	_onKeyDown(e) {
		if (this._options.keyboardNavigation) {
			var code = e.key ?? e.keyCode;

			// if code/e.which is null
			code ??= e.charCode;

			if ((code === 'Escape' || code === 27) && this._options.exitOnEsc === true) {
				//escape key pressed, exit the intro
				//check if exit callback is defined
				this._exitIntro('skip');
			} else if (code === 'ArrowLeft' || code === 37) {
				//left arrow
				if (!this._options.hide_previous_step_button) this.previousStep();
			} else if (code === 'ArrowRight' || code === 39) {
				const isLastStep = this._introItems.length - 1 === this._currentStep;
				//right arrow
				if (!this._options.hideNextAlways && !isLastStep) this.nextStep();
			} else if (code === 'Enter' || code === 13) {
				//srcElement === ie
				var target = e.target || e.srcElement;
				if (target === this.buttonPrevLayer) {
					//user hit enter while focusing on previous button
					this.previousStep();
				} else if (target === this.buttonSkipLayer) {
					//user hit enter while focusing on skip button
					this._exitIntro('complete');
				} else if (target && target.getAttribute('data-stepnumber')) {
					// user hit enter while focusing on step bullet
					target.click();
				} else {
					//default behavior for responding to enter
					this.nextStep();
				}

				//prevent default behaviour on hitting Enter, to prevent steps being skipped in some browsers
				if (e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false;
				}
			}
		}
	}

	/*
	  * makes a copy of the object
	  * @api private
	  * @method _cloneObject
	 */
	_cloneObject = (object) => {
		if (object === null || typeof (object) !== 'object' || typeof (object.nodeType) !== 'undefined') {
			return object;
		}
		var temp = {};
		for (var key in object) {
			if (typeof (window.jQuery) !== 'undefined' && object[key] instanceof window.jQuery) {
				temp[key] = object[key];
			} else {
				temp[key] = this._cloneObject(object[key]);
			}
		}
		return temp;
	}


	placeTooltip = (targetItem) => {
		this._placeTooltip(targetItem, this.highlightLayer, this.tooltipLayer, this.arrowLayer, this.tooltipNumberLayer);
	}

	/**
	 * Render tooltip box in the page
	 *
	 * @api private
	 * @method _placeTooltip
	 * @param {HTMLElement} targetElement
	 * @param {HTMLElement} tooltipLayer
	 * @param {HTMLElement} arrowLayer
	 * @param {HTMLElement} helperNumberLayer
	 */
	_placeTooltip = (targetItem, highlightLayer, tooltipLayer, arrowLayer, helperNumberLayer) => {
		var tooltipCssClass = '',
			currentStepObj,
			currentTooltipPosition;
		const tooltipTransitionBkp = tooltipLayer.style.transition;
		tooltipLayer.style.transition = 'none !important';
		//reset the old style
		tooltipLayer.style.top = null;
		tooltipLayer.style.right = null;
		tooltipLayer.style.bottom = null;
		tooltipLayer.style.left = null;
		tooltipLayer.style.marginLeft = null;
		tooltipLayer.style.marginTop = null;

		arrowLayer.style.display = 'inherit';


		if (targetItem?.hidden_meta?.ext?.build_with_wp_editor === '1') {
			$(this.tooltipTextLayer).addClass('dpintro-tooltip-text--rt');
		}
		else {
			$(this.tooltipTextLayer).removeClass('dpintro-tooltip-text--rt');
		}

		if (this._options.customTextStylesEn) {
			$(this.tooltipTextLayer).addClass('dpintro-tooltip-text--cs');
		}
		else {
			$(this.tooltipTextLayer).removeClass('dpintro-tooltip-text--cs');
		}

		let windowSize = this._getWinSize();
		let maxBottom = $(document).height();
		if (targetItem.isFixedPosition) {
			maxBottom = windowSize.height + $(window).scrollTop();
		}
		const documentBB = DPBoundingBox.actualizeBottomAndRightInBoundingBox({
			top: 0,
			left: 0,
			width: windowSize.width,
			height: maxBottom
		});

		let arrowHalfSize = parseFloat($(arrowLayer).css('border-top-width'));
		if (isNaN(arrowHalfSize)) arrowHalfSize = $(arrowLayer).outerWidth() / 2;

		const arrowSize = 2 * arrowHalfSize;

		if (typeof (helperNumberLayer) !== 'undefined' && helperNumberLayer !== null) {
			helperNumberLayer.style.top = null;
			helperNumberLayer.style.left = null;
		}

		//prevent error when `this._currentStep` is undefined
		if (!this._introItems[this._currentStep]) return;

		//if we have a custom css class for each step
		currentStepObj = this._introItems[this._currentStep];
		if (typeof (currentStepObj.tooltipClass) === 'string') {
			tooltipCssClass = currentStepObj.tooltipClass;
		} else {
			tooltipCssClass = this._options.tooltipClass;
		}

		tooltipLayer.className = LAYER_CLASSES.tooltip;
		$(tooltipLayer).addClass(tooltipCssClass.replace(/^\s+|\s+$/g, ''));
		tooltipLayer.setAttribute('role', 'dialog');

		currentTooltipPosition = this._introItems[this._currentStep].position;


		if (targetItem.isDummyElement) {
			if (windowSize.width < 600) currentTooltipPosition = 'center-top-aligned';
			else currentTooltipPosition = 'center';
		} else {
			currentTooltipPosition = this._determineAutoPosition(targetItem, tooltipLayer, currentTooltipPosition, arrowSize + this._options.tooltipDistanceFromTarget);
		}

		$(tooltipLayer).addClass(`${LAYER_CLASSES.tooltip}--${currentTooltipPosition}`);

		const targetOffset = DPBoundingBox.intersectBoundingBoxes(DPBoundingBox.getElBoundingBox(highlightLayer, false), documentBB);
		const tooltipOffset = DPBoundingBox.getElBoundingBox(tooltipLayer, false);

		const helperNumberLayerOffset = DPBoundingBox.getElBoundingBox(helperNumberLayer, false, false, 'EMPTY_OFFSET');
		let tooltipRadius = parseFloat($(tooltipLayer).css('border-top-right-radius')); // All are in all themes the same
		if (isNaN(tooltipRadius)) tooltipRadius = 0;
		const arrowAlignNormOffset = {
			x: Math.max(Math.min(tooltipOffset.width, targetOffset.width) * this._options.arrowAlignNormCoef, arrowSize + tooltipRadius),
			y: Math.max(Math.min(tooltipOffset.height, targetOffset.height) * this._options.arrowAlignNormCoef, arrowSize + tooltipRadius)
		};
		const numberCoef = { x: Math.min(helperNumberLayerOffset.width / targetOffset.width, 0.9), y: Math.min(helperNumberLayerOffset.height / targetOffset.height, 0.9) };
		const numberLayerHalfOffset = { x: helperNumberLayerOffset.width / (2 - numberCoef.x), y: helperNumberLayerOffset.height / (2 - numberCoef.y) };

		const helperNumberLayerPos = { left: -numberLayerHalfOffset.x, top: -numberLayerHalfOffset.y }; // default top left
		const arrowLayerPos = { top: -arrowSize, left: arrowAlignNormOffset.x }; // default top left aligned

		const tooltipLayerPos = { top: 0, left: 0 };


		//currentTooltipPosition = 'left';
		if (!this.isFixedTooltipBottomTheme()) {
			arrowLayer.className = LAYER_CLASSES.arrow;
			let arrowPos = 'top';
			switch (currentTooltipPosition) {
				case 'top-right-aligned':
					arrowPos = 'bottom';
					tooltipLayerPos.top = - tooltipOffset.height - arrowHalfSize - this._options.tooltipDistanceFromTarget;
					tooltipLayerPos.left = targetOffset.width - tooltipOffset.width;

					helperNumberLayerPos.top = targetOffset.height - numberLayerHalfOffset.y;
					helperNumberLayerPos.left = - numberLayerHalfOffset.x;

					arrowLayerPos.left = tooltipOffset.width - arrowAlignNormOffset.x - arrowSize;
					arrowLayerPos.top = tooltipOffset.height;
					break;
				case 'top-middle-aligned':
					arrowPos = 'bottom';
					tooltipLayerPos.top = (- tooltipOffset.height - arrowHalfSize - this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.left = (targetOffset.width - tooltipOffset.width) / 2;

					helperNumberLayerPos.top = targetOffset.height - numberLayerHalfOffset.y;
					helperNumberLayerPos.left = - numberLayerHalfOffset.x;

					arrowLayerPos.left = tooltipOffset.width / 2 - arrowHalfSize;
					arrowLayerPos.top = tooltipOffset.height;
					break;
				case 'top-left-aligned':
				// falls through
				case 'top':
					arrowPos = 'bottom';
					tooltipLayerPos.top = (- tooltipOffset.height - arrowHalfSize - this._options.tooltipDistanceFromTarget);

					helperNumberLayerPos.top = targetOffset.height - numberLayerHalfOffset.y;
					helperNumberLayerPos.left = targetOffset.width - numberLayerHalfOffset.x;

					arrowLayerPos.left = arrowAlignNormOffset.x;
					arrowLayerPos.top = tooltipOffset.height;
					break;

				case 'right-top-aligned':
					tooltipLayerPos.left = (targetOffset.width + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = 0;

					tooltipLayer.style.width = tooltipOffset.width + 'px';
					arrowPos = 'left';
					arrowLayerPos.left = -arrowSize;
					arrowLayerPos.top = arrowAlignNormOffset.y;

					helperNumberLayerPos.top = targetOffset.height - numberLayerHalfOffset.y;
					break;

				case 'right-bottom-aligned':
					tooltipLayerPos.left = (targetOffset.width + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = targetOffset.height - tooltipOffset.height;

					tooltipLayer.style.width = tooltipOffset.width + 'px';

					arrowPos = 'left';

					arrowLayerPos.left = -arrowSize;
					arrowLayerPos.top = tooltipOffset.height - arrowAlignNormOffset.y - arrowSize;

					helperNumberLayerPos.top = - numberLayerHalfOffset.y;
					break;

				case 'right-middle-aligned':
				case 'right':
					tooltipLayerPos.left = (targetOffset.width + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = (targetOffset.height - tooltipOffset.height) / 2;
					arrowPos = 'left';
					arrowLayerPos.left = -arrowSize;
					arrowLayerPos.top = tooltipOffset.height / 2 - arrowHalfSize;
					break;

				case 'left-top-aligned':
					tooltipLayerPos.left = (- arrowHalfSize - tooltipOffset.width - this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = 0;
					tooltipLayer.style.width = tooltipOffset.width + 'px';
					arrowPos = 'right';
					arrowLayerPos.left = tooltipOffset.width;
					arrowLayerPos.top = arrowAlignNormOffset.y;
					helperNumberLayerPos.left = targetOffset.width - numberLayerHalfOffset.x;
					helperNumberLayerPos.top = targetOffset.height - numberLayerHalfOffset.y;
					break;

				case 'left-bottom-aligned':
					tooltipLayerPos.left = (- arrowHalfSize - tooltipOffset.width - this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = targetOffset.height - tooltipOffset.height;
					tooltipLayer.style.width = tooltipOffset.width + 'px';
					arrowPos = 'right';
					arrowLayerPos.left = tooltipOffset.width;
					arrowLayerPos.top = tooltipOffset.height - arrowAlignNormOffset.y - arrowSize;
					helperNumberLayerPos.left = targetOffset.width - numberLayerHalfOffset.x;
					helperNumberLayerPos.top = - numberLayerHalfOffset.y;
					break;

				case 'left-middle-aligned':
				case 'left':
					tooltipLayerPos.left = (- arrowHalfSize - tooltipOffset.width - this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.top = (targetOffset.height - tooltipOffset.height) / 2;
					tooltipLayer.style.width = tooltipOffset.width + 'px';
					arrowPos = 'right';
					arrowLayerPos.left = tooltipOffset.width;
					arrowLayerPos.top = tooltipOffset.height / 2 - arrowHalfSize;
					helperNumberLayerPos.left = targetOffset.width - numberLayerHalfOffset.x;
					break;

				case 'center': {
					arrowLayer.style.display = 'none';
					const tooltipPos = {
						left: (targetOffset.width - tooltipOffset.width) / 2,
						top: (targetOffset.height - tooltipOffset.height) / 2
					};
					tooltipLayerPos.left = tooltipPos.left;
					tooltipLayerPos.top = tooltipPos.top;
					helperNumberLayerPos.left = tooltipPos.left + tooltipOffset.width - numberLayerHalfOffset.x;
					helperNumberLayerPos.top = tooltipPos.top - numberLayerHalfOffset.y;
					break;
				}
				case 'center-top-aligned':
					arrowLayer.style.display = 'none';
					tooltipLayerPos.left = (targetOffset.width - tooltipOffset.width) / 2;
					tooltipLayerPos.top = this._options.centerTopBottomPosOffset;
					helperNumberLayerPos.left = tooltipLayerPos.left + tooltipOffset.width - numberLayerHalfOffset.x;
					helperNumberLayerPos.top = tooltipLayerPos.top - numberLayerHalfOffset.y;
					break;
				case 'bottom-right-aligned':
					arrowPos = 'top';
					tooltipLayerPos.top = (targetOffset.height + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.left = targetOffset.width - tooltipOffset.width;

					arrowLayerPos.left = tooltipOffset.width - arrowAlignNormOffset.x - arrowSize;
					arrowLayerPos.top = -arrowSize;
					break;

				case 'bottom-middle-aligned':
					tooltipLayerPos.top = (targetOffset.height + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					tooltipLayerPos.left = (targetOffset.width - tooltipOffset.width) / 2;
					arrowPos = 'top';
					arrowLayerPos.left = tooltipOffset.width / 2 - arrowHalfSize;
					arrowLayerPos.top = -arrowSize;
					break;

				default:
					tooltipLayerPos.top = (targetOffset.height + arrowHalfSize + this._options.tooltipDistanceFromTarget);
					helperNumberLayerPos.left = targetOffset.width - numberLayerHalfOffset.x;
					arrowPos = 'top';
					arrowLayerPos.left = arrowAlignNormOffset.x;
					arrowLayerPos.top = -arrowSize;
			}
			$(arrowLayer).addClass(`${LAYER_CLASSES.arrow}--${arrowPos}`);
			if (currentTooltipPosition.startsWith('top') || currentTooltipPosition.startsWith('bottom')) {
				let diff = 0;

				const tooltipReferenceLayerOffset = $(this.tooltipReferenceLayer).offset();
				const tooltipWindowOffset = {
					left: tooltipReferenceLayerOffset.left + tooltipLayerPos.left,
					top: tooltipReferenceLayerOffset.top + tooltipLayerPos.top
				};
				if (tooltipWindowOffset.left < this._options.tooltipMinMarginX) {
					diff = this._options.tooltipMinMarginX - tooltipWindowOffset.left;
					if (currentTooltipPosition.endsWith('right-aligned')) diff = -diff;
					tooltipLayerPos.left = this._options.tooltipMinMarginX - tooltipReferenceLayerOffset.left;
				}
				else if (tooltipWindowOffset.left + tooltipOffset.width > windowSize.width - this._options.tooltipMinMarginX) {
					const newLeft = windowSize.width - tooltipOffset.width - this._options.tooltipMinMarginX;
					diff = newLeft - tooltipWindowOffset.left;
					if (currentTooltipPosition.endsWith('left-aligned')) diff = -diff;
					tooltipLayerPos.left = newLeft - tooltipReferenceLayerOffset.left;
				}
				arrowLayerPos.left += diff;
			}
			// Set tooltip layer evaluated pos
			tooltipLayer.style.left = tooltipLayerPos.left + 'px';
			tooltipLayer.style.top = tooltipLayerPos.top + 'px';
		}
		else {
			if (helperNumberLayer) {
				if (targetOffset.left - helperNumberLayerOffset.width < 0) {
					this._addClass(helperNumberLayer, 'center');
				}
				else {
					helperNumberLayer.style.position = 'absolute';
					helperNumberLayerPos.left = - 0.7 * helperNumberLayerOffset.width;
					helperNumberLayerPos.top = - 0.7 * helperNumberLayerOffset.height;
					this._removeClass(helperNumberLayer, 'center');
				}
			}

			const fixedTooltipHeight = this._getFixedTooltipOffset();
			if (targetOffset.top + targetOffset.height > maxBottom - fixedTooltipHeight.bottom && !currentStepObj.isDummyElement) {
				this._addClass(tooltipLayer, `${LAYER_CLASSES.tooltip}--on-top`);
				$(this._mainElement).addClass(`${LAYER_CLASSES.main}--on-top`);
			}
			else {
				this._removeClass(tooltipLayer, `${LAYER_CLASSES.tooltip}--on-top`);
				$(this._mainElement).removeClass(`${LAYER_CLASSES.main}--on-top`);
			}

		}

		if (arrowLayer) {
			arrowLayer.style.left = arrowLayerPos.left + 'px';
			arrowLayer.style.top = arrowLayerPos.top + 'px';
		}
		if (helperNumberLayer) {
			const transitionBkp = helperNumberLayer.style.transition;
			helperNumberLayer.style.transition = 'none !important';
			helperNumberLayer.style.left = helperNumberLayerPos.left + 'px';
			helperNumberLayer.style.top = helperNumberLayerPos.top + 'px';
			const currentOffsetToCheck = $(helperNumberLayer).offset();


			$(helperNumberLayer).offset({
				left: Math.min(Math.max(0, currentOffsetToCheck.left), windowSize.width - helperNumberLayerOffset.width),
				top: Math.min(Math.max(0, currentOffsetToCheck.top), maxBottom - helperNumberLayerOffset.height)
			});
			helperNumberLayer.style.transition = transitionBkp;
		}

		// 'fix':) rounding issue of gap between tooltip and arrow
		if (currentTooltipPosition.startsWith('top')) {
			const tooltipBottom = $(tooltipLayer).offset().top + $(tooltipLayer).outerHeight();
			const arrowOffset = $(arrowLayer).offset();
			//const diff = Math.abs(tooltipBottom - arrowOffset.top);
			$(arrowLayer).offset({ top: tooltipBottom - 0.3, left: arrowOffset.left });
		}

		tooltipLayer.style.transition = tooltipTransitionBkp;

	}



	/**
	 * Determines the position of the tooltip based on the position precedence and availability
	 * of screen space.
	 *
	 * @param {Object}    targetElement
	 * @param {Object}    tooltipLayer
	 * @param {String}    desiredTooltipPosition
	 * @return {String}   calculatedPosition
	 */
	_determineAutoPosition = (targetItem, tooltipLayer, desiredTooltipPosition, arrowSize, autoWidth = true) => {

		const targetElement = targetItem.element;
		const possiblePositionsScoreInc = {};
		this._options.positionPrecedence.forEach((position) => {
			possiblePositionsScoreInc[position] = {
				score: 0,
				disabled: false
			};
		});

		if (autoWidth) $(tooltipLayer).css('width', 'auto');
		const windowBB = this._getWinSize();
		const targetBB = DPBoundingBox.getElBoundingBox(targetElement);
		const tooltipBB = DPBoundingBox.getElBoundingBox(tooltipLayer);


		const tooltipHeightArrowInc = tooltipBB.height + arrowSize;
		const tooltipWidthArrowInc = tooltipBB.width + arrowSize;



		/*
		* auto determine position 
		*/
		let calculatedPosition = 'bottom';
		let maxBottom = $(document).height();
		if (targetItem.isFixedPosition) {
			maxBottom = windowBB.height + $(window).scrollTop();
		}

		const minTargetCenterHeigh = (desiredTooltipPosition === 'center') ? targetBB.height : targetBB.height / 2;
		const targetWithTooltipHeightTopBottom = tooltipHeightArrowInc + targetBB.height;
		const heightScoreTopBottom = (windowBB.height - targetWithTooltipHeightTopBottom) / windowBB.height;

		// Check for space below
		possiblePositionsScoreInc['bottom'].disabled = targetBB.bottom + tooltipHeightArrowInc > maxBottom;
		possiblePositionsScoreInc['bottom'].score += heightScoreTopBottom;


		// Check for space above
		possiblePositionsScoreInc['top'].disabled = targetBB.top - tooltipHeightArrowInc < 0;
		possiblePositionsScoreInc['top'].score += heightScoreTopBottom;

		// Check for space to the right
		possiblePositionsScoreInc['right'].disabled = targetBB.right + tooltipWidthArrowInc > windowBB.width;
		possiblePositionsScoreInc['right'].score += 1 - (tooltipWidthArrowInc / (windowBB.width - targetBB.right));


		// Check for space to the left
		possiblePositionsScoreInc['left'].disabled = targetBB.left - tooltipWidthArrowInc < 0;
		possiblePositionsScoreInc['left'].score += 1 - (tooltipWidthArrowInc / targetBB.left);

		// Check for space inside
		possiblePositionsScoreInc['center'].disabled = targetBB.width <= tooltipBB.width || minTargetCenterHeigh <= tooltipBB.height;
		if (targetBB.width - tooltipBB.width < targetBB.height - tooltipBB.height) {
			possiblePositionsScoreInc['center'].score += (targetBB.width - tooltipBB.width) / targetBB.width - 0.5;
		}
		else {
			possiblePositionsScoreInc['center'].score += (targetBB.height - tooltipBB.height) / targetBB.height - 0.5;
		}

		const possiblePositionsScoreIncArr = [];
		Object.keys(possiblePositionsScoreInc).forEach((pos) => {
			if (!possiblePositionsScoreInc[pos].disabled) {
				possiblePositionsScoreIncArr.push({
					position: pos,
					score: possiblePositionsScoreInc[pos].score
				});
			}
		});
		possiblePositionsScoreIncArr.sort((a, b) => {
			return b.score - a.score;
		});
		//console.log(possiblePositionsScoreIncArr);

		const possiblePositions = possiblePositionsScoreIncArr.map((val) => {
			return val.position;
		});
		//console.log(possiblePositions);







		// @var {String}  ex: 'right-aligned'
		var desiredAlignment = (function (pos) {
			var hyphenIndex = pos.indexOf('-');
			if (hyphenIndex !== -1) {
				// has alignment
				return pos.substr(hyphenIndex);
			}
			return '';
		})(desiredTooltipPosition || '');

		// strip alignment from position
		if (desiredTooltipPosition) {
			// ex: "bottom-right-aligned"
			// should return 'bottom'
			desiredTooltipPosition = desiredTooltipPosition.split('-')[0];
		}

		if (possiblePositions.length) {
			if (desiredTooltipPosition !== 'auto' &&
				possiblePositions.indexOf(desiredTooltipPosition) > -1) {
				// If the requested position is in the list, choose that
				calculatedPosition = desiredTooltipPosition;
			} else {
				// Pick the first valid position, in order
				calculatedPosition = possiblePositions[0];
			}
		}
		else if (autoWidth) {
			// No space to put tooltip, try increase a width if there is a space, and evaluate again
			//console.log('width increasing');
			const maxWidth = windowBB.width * 0.95 - 40 - 1;
			if (tooltipBB.width < maxWidth) {
				$(tooltipLayer).css('width', maxWidth + 'px');
				calculatedPosition = this._determineAutoPosition(targetItem, tooltipLayer, desiredTooltipPosition, arrowSize, false);
			}
		}

		// top and bottom alignments
		if (['top', 'bottom'].indexOf(calculatedPosition) !== -1) {
			calculatedPosition += this._determineAutoAlignmentX(targetBB, tooltipWidthArrowInc, windowBB, desiredAlignment);
		}
		//  left and right positions alignments
		if (['left', 'right'].indexOf(calculatedPosition) !== -1) {
			calculatedPosition += this._determineAutoAlignmentY(targetBB, tooltipHeightArrowInc, maxBottom, desiredAlignment);
		}
		//console.log(calculatedPosition);

		return calculatedPosition;
	}

	/**
	* auto-determine alignment
	* @param {Integer}  offsetLeft
	* @param {Integer}  tooltipWidth
	* @param {Object}   windowSize
	* @param {String}   desiredAlignment
	* @return {String}  calculatedAlignment
	*/
	_determineAutoAlignmentX = (targetBB, tooltipWidth, windowSize, desiredAlignment) => {

		const winWidth = Math.min(windowSize.width, window.screen.width);
		const possibleAlignments = ['-middle-aligned', '-left-aligned', '-right-aligned'];
		let calculatedAlignment = '';

		if (targetBB.left + tooltipWidth > winWidth) {
			this._removeEntry(possibleAlignments, '-left-aligned');
		}

		const targetCenterX = targetBB.left + targetBB.width / 2;
		if (targetCenterX - 0.6 * tooltipWidth < 0 ||
			targetCenterX + 0.6 * tooltipWidth > winWidth) {
			this._removeEntry(possibleAlignments, '-middle-aligned');
		}

		if (targetBB.right - tooltipWidth < 0) {
			this._removeEntry(possibleAlignments, '-right-aligned');
		}

		if (possibleAlignments.length) {
			if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
				// the desired alignment is valid
				calculatedAlignment = desiredAlignment;
			} else {
				// pick the first valid position, in order
				calculatedAlignment = possibleAlignments[0];
			}
		} else {
			// if screen width is too small 
			// for ANY alignment, middle is 
			// probably the best for visibility
			calculatedAlignment = '-middle-aligned';
		}

		return calculatedAlignment;
	}

	/**
	* auto-determine alignment
	* @param {Integer}  offsetLeft
	* @param {Integer}  tooltipHeight
	* @param {Object}   windowSize
	* @param {String}   desiredAlignment
	* @return {String}  calculatedAlignment
	*/
	_determineAutoAlignmentY = (targetBB, tooltipHeight, maxBottom, desiredAlignment) => {


		const possibleAlignments = ['-middle-aligned', '-top-aligned', '-bottom-aligned'];
		let calculatedAlignment = '';

		if (targetBB.top + tooltipHeight > maxBottom) {
			this._removeEntry(possibleAlignments, '-top-aligned');
		}

		const targetCenterY = targetBB.top + targetBB.height / 2;
		if (targetCenterY - tooltipHeight / 2 < 0 ||
			targetCenterY + tooltipHeight / 2 > maxBottom) {
			this._removeEntry(possibleAlignments, '-middle-aligned');
		}

		if (targetBB.bottom - tooltipHeight < 0) {
			this._removeEntry(possibleAlignments, '-bottom-aligned');
		}

		if (possibleAlignments.length) {
			if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
				// the desired alignment is valid
				calculatedAlignment = desiredAlignment;
			} else {
				// pick the first valid position, in order
				calculatedAlignment = possibleAlignments[0];
			}
		} else {
			// if screen width is too small 
			// for ANY alignment, middle is 
			// probably the best for visibility
			calculatedAlignment = '-middle-aligned';
		}

		return calculatedAlignment;
	}

	/**
	 * Remove an entry from a string array if it's there, does nothing if it isn't there.
	 *
	 * @param {Array} stringArray
	 * @param {String} stringToRemove
	 */
	_removeEntry = (stringArray, stringToRemove) => {
		if (stringArray.indexOf(stringToRemove) > -1) {
			stringArray.splice(stringArray.indexOf(stringToRemove), 1);
		}
	}

	/**
	 * Update the position of the helper layer on the screen
	 *
	 * @api private
	 * @method _setHelperLayerPosition
	 * @param {Object} layer
	 */
	_setLayerPosition = (layer, addClass = null, remClass = null) => {
		if (layer) {
			//prevent error when `this._currentStep` in undefined
			if (!this._introItems[this._currentStep]) return;

			var currentElement = this._introItems[this._currentStep],
				elementPosition = DPBoundingBox.getElBoundingBox(currentElement.element, true),
				lithBoxBgPadding = this._options.helperElementPadding / 2;

			var bb = DPBoundingBox.actualizeHeightAndWidthInBoundingBox({
				top: Math.max(elementPosition.top - lithBoxBgPadding, 0),
				left: Math.max(elementPosition.left - lithBoxBgPadding, 0),
				bottom: Math.min(elementPosition.bottom + lithBoxBgPadding, $(document).innerHeight()),
				right: Math.min(elementPosition.right + lithBoxBgPadding, $(window).innerWidth()),
			});

			if (addClass) this._addClass(layer, addClass);
			if (remClass) this._removeClass(layer, remClass);

			if (this._introItems[this._currentStep].isFixedPosition) {
				this._addClass(layer, 'dpintro-fixed-pos-tooltip');
				bb.top -= $(window).scrollTop();
				bb.left == $(window).scrollLeft();
			} else {
				this._removeClass(layer, 'dpintro-fixed-pos-tooltip');
			}

			if (this._introItems[this._currentStep].isFixedPosition) {
				$(layer).css({
					top: bb.top + 'px',
					left: bb.left + 'px',
					width: bb.width + 'px',
					height: bb.height + 'px'
				});
			}
			else {
				$(layer).offset({
					top: bb.top,
					left: bb.left
				});

				$(layer).css({
					//top: bb.top + 'px',
					//left: bb.left + 'px',
					width: bb.width + 'px',
					height: bb.height + 'px'
				});

			}


		}
	}

	/**
	 * Add disableinteraction layer and adjust the size and position of the layer
	 *
	 * @api private
	 * @method _disableInteraction
	 */
	_disableInteraction() {
		if (!this.disableInteractionLayer) {
			this.disableInteractionLayer = document.createElement('div');
			this.disableInteractionLayer.className = LAYER_CLASSES.disableInteraction;
			this._mainElement.appendChild(this.disableInteractionLayer);
		}
		this.updateIterateAfterClick(this._introItems[this._currentStep]);
		this._setLayerPosition(this.disableInteractionLayer);
	}

	_enableInteraction(clearIterateAfterClickOnly = false) {
		//remove disableInteractionLayer
		if (this.disableInteractionLayer) {
			this.disableInteractionLayer.parentNode.removeChild(this.disableInteractionLayer);
			this.disableInteractionLayer = null;
		}
		this.updateIterateAfterClick(this._introItems[this._currentStep], clearIterateAfterClickOnly);

	}

	_isInteractionEnabled() {
		return !this.disableInteractionLayer;
	}

	/**
	 * Setting anchors to behave like buttons
	 *
	 * @api private
	 * @method _setAnchorAsButton
	 */
	_setAnchorAsButton = (anchor) => {
		anchor.setAttribute('role', 'button');
		anchor.tabIndex = 0;
	}

	_actualizeStepElement = (stepItem, checkRefElVis = true) => {
		let skipStep = false;
		if (stepItem) {
			const isMobileSize = this._isMobileSize();
			if (stepItem.is_mobile_menu_active_element) {
				if (stepItem.alt_mobile_selector) {
					const mobMenuEl = $S(stepItem.alt_mobile_selector);
					if (mobMenuEl && mobMenuEl.length) {
						stepItem.element = mobMenuEl[0];
						this.resetStepAsDummy(stepItem);
						return;
					}
				}
			}
			else if (stepItem.alt_mobile_selector && isMobileSize) {
				const el = $S(stepItem.alt_mobile_selector, null);
				if (el && el.length) stepItem.element = el[0];
				else stepItem.element = null;
			}
			else if (stepItem.selector) {
				const el = $S(stepItem.selector, null);
				if (el && el.length) stepItem.element = el[0];
				else stepItem.element = null;
			}
			else stepItem.element = null;
			if (checkRefElVis) {
				skipStep = this._shouldBeStepSkipped(stepItem, isMobileSize);
				this.setNotVisibleRefBullet(LAYER_CLASSES.bullets, stepItem.step, skipStep);
			}

			if (this._options.dpDebugEn && (!stepItem.element || !$(stepItem.element).is(':visible'))) {
				console.log('Current not visible!');
			}

			if ((!stepItem.element || this.dummyElement === stepItem.element)) {

				this.setStepAsDummy(stepItem);
			}
			else {
				this.resetStepAsDummy(stepItem);
			}
			if (this._options.dpDebugEn) {
				console.log('Current step:', stepItem);
			}

			// iterate after click
			this.updateIterateAfterClick(stepItem);
		}
		return skipStep;
	}

	updateIterateAfterClick(stepItem, clearOnly = false) {
		if (stepItem && stepItem.element) $(stepItem.element).off('click', this.iterateAfterClick);
		if (!clearOnly && this.isIterateAfterClick(stepItem)) $(stepItem.element).on('click', this.iterateAfterClick);
	}


	iterateAfterClick = () => {
		if (!this.isBuilder && this._introItems[this._currentStep]) {
			let delay = this._introItems[this._currentStep].enable_interaction?.ext?.iterate_after_click_delay_ms ?? 500;
			this._clearCurrentStepElement();
			this.inHighlightLayerAnimation.createAndRun();
			setTimeout(() => {
				this.inHighlightLayerAnimation.destroy();
				this.goToNextStep();
			}, delay);
		}
	}


	isIterateAfterClick(stepData) {
		return stepData && stepData.element && stepData.enable_interaction.val == '1' && !stepData.isDummyElement && stepData.enable_interaction.ext?.iterate_after_click == '1';
	}

	_isMobileSize() {
		const winSize = this._getWinSize();
		return this._options.mobileBreakpoints && winSize.width <= this._options.mobileBreakpoints.mobile;
	}

	_shouldBeStepSkipped(stepItem, isMobileSize) {
		let skipStep = false;
		if (this._options.skip_absent_ref_el
			&& (stepItem.selector || (isMobileSize && stepItem.alt_mobile_selector))
			&& (!stepItem.element || !$(stepItem.element).is(':visible'))
		) {
			skipStep = true;
		}
		return skipStep;

	}

	_isElementHidden(el) {
		return (el.offsetParent === null);
	}

	_actualizeTargetPosition(targetItem, noAfterEvent) {
		if (this.highlightLayer && this.tooltipReferenceLayer) {
			//console.log(targetItem.element);
			this._trackingTargetInProgress = true;
			this.highlightLayer.style.opacity = 0.35;
			this.tooltipReferenceLayer.style.opacity = 0.35;
			this._setLayerPosition(this.highlightLayer);
			this._setLayerPosition(this.tooltipReferenceLayer);
			this._placeTooltip(targetItem, this.highlightLayer, this.tooltipLayer, this.arrowLayer, this.tooltipNumberLayer);
			if (targetItem.targetMovedTimer) clearTimeout(targetItem.targetMovedTimer);
			targetItem.targetMovedTimer = setTimeout(() => {
				this._setLayerPosition(this.highlightLayer);
				this._setLayerPosition(this.tooltipReferenceLayer);
				this._placeTooltip(targetItem, this.highlightLayer, this.tooltipLayer, this.arrowLayer, this.tooltipNumberLayer);
				this.highlightLayer.style.opacity = 1;
				this.tooltipReferenceLayer.style.opacity = 1;
				this._trackingTargetInProgress = false;

				if (!this._checkTargetPosition(targetItem, noAfterEvent)) return;

			}, 400);
		}
	}

	getStartStepIdx() {
		if (this.startStep) return this.startStep;
		return 0;
	}

	getEndStepIdx() {
		if (this.endStep) return this.endStep;
		return this._introItems.length - 1;
	}




	_showElementDelayed = (targetItem, noAfterEvent = false, backward = false) => {
		var highlightClass = LAYER_CLASSES.highlight;
		var scrollParent;
		var wasSetStartStepWhenReady = false;
		var wasSetEndStepWhenReady = false;

		if (this._actualizeStepElement(targetItem)) {
			if (!backward) {
				if (this._currentStep < this._introItems.length - 1) {
					if (this._currentStep === 0) this.setStartStepWhenReady = true;
					this.goToNextStep();
				}
				else {
					this.setEndStepWhenReady = true;
					this.goToPreviousStep();
				}
			}
			else {
				if (!this.goToPreviousStep()) {
					this.setStartStepWhenReady = true;
					this.goToNextStep();
				}
			}
			return;
		}

		if (this.setEndStepWhenReady) {
			this.endStep = this._currentStep;
			this.setEndStepWhenReady = false;
			wasSetEndStepWhenReady = true;
		}
		if (this.setStartStepWhenReady) {
			this.startStep = this._currentStep;
			this.setStartStepWhenReady = false;
			wasSetStartStepWhenReady = true;
		}

		this.refreshStepNumber();

		this._currentTargetElement = targetItem.element;
		//check for a current step highlight class
		if (typeof (targetItem.highlightClass) === 'string' && targetItem.highlightClass) {
			highlightClass += (' ' + targetItem.highlightClass);
		}
		//check for options highlight class
		if (typeof (this._options.highlightClass) === 'string' && this._options.highlightClass) {
			highlightClass += (' ' + this._options.highlightClass);
		}

		// Check if element has fixed position
		targetItem.isFixedPosition = this._isFixed(targetItem.element);

		//if (targetItem.isFixedPosition) console.log('Fixed position detected');


		this.highlightLayer = this._mainElement.querySelector('.' + highlightClass);
		if (this.highlightLayer === null) {
			this._initLayers(targetItem, highlightClass);
		}

		if (wasSetEndStepWhenReady) {
			for (let i = this._currentStep + 1; i < this._introItems.length; i++) {
				this.setNotVisibleRefBullet(LAYER_CLASSES.bullets, i + 1, true);
			}
		}
		if (wasSetStartStepWhenReady) {
			for (let i = this._currentStep - 1; i >= 0; i--) {
				this.setNotVisibleRefBullet(LAYER_CLASSES.bullets, i + 1, true);
			}
		}

		var isFixedTooltipBottom = this.isFixedTooltipBottomTheme();

		//hide layers
		this.tooltipLayer.style.opacity = 0;
		this.bulletsLayer.style.opacity = 0;
		if (isFixedTooltipBottom) {
			this._addClass(this.tooltipLayer, 'hidden');
		}
		else {
			this.tooltipLayer.style.opacity = 0;
		}
		//$(this.highlightLayer).fadeOut(340);
		$(this.overlayLayer).css('opacity', this._options.overlayOpacityCoefWhenScroll * this._options.overlayOpacity);

		if (this.tooltipNumberLayer !== null) {
			$(this.tooltipNumberLayer).css('opacity', 0);
		}

		// scroll to element
		scrollParent = this._getScrollParent(targetItem.element);
		//if (this._options.dpDebugEn) console.log('Scroll parent: ' + scrollParent);
		if (scrollParent !== document.body) {
			// target is within a scrollable element
			this._scrollParentToElement(scrollParent, targetItem.element);
		}

		this.highlightLayer.className = highlightClass;
		if (targetItem.isDummyElement) $(this.highlightLayer).addClass('highlight-dummy');
		else $(this.highlightLayer).removeClass('highlight-dummy');
		this._setLayerPosition(this.highlightLayer);
		this._setLayerPosition(this.tooltipReferenceLayer);
		this.highlightLayer.style.opacity = 0.1;
		this._clearCurrentStepElement();
		this._fixTargetLowContrast(this.highlightLayer, targetItem.element);

		//we should wait until the CSS3 transition is competed (it's 0.3 sec) to prevent incorrect `height` and `width` calculation
		if (this._lastShowElementTimer) window.clearTimeout(this._lastShowElementTimer);
		this._lastShowElementTimer = window.setTimeout(() => {
			if (!this.ending) {
				this._setShowElement(targetItem.element);
				this._actualizeNavigation();
				// If position change due animation or sticky menu, follow target
				$(targetItem.element).onOffsetOrDimensionChanged((source) => {
					//console.log(targetItem.element, source);
					if (this.isFollowTargetPositionEnabled && source == targetItem.element && targetItem.step - 1 === this._currentStep) {
						if (this.highlightLayer && this.tooltipReferenceLayer) {
							this._actualizeTargetPosition(targetItem, noAfterEvent);
						}
					}
				});

				this._mainElement.setAttribute('id', 'dpintro-step-' + targetItem.step);

				//set current step to the label
				if (this.tooltipNumberLayer !== null) {
					this.tooltipNumberLayer.innerHTML = targetItem.step;
				}
				//set current tooltip text
				this.tooltipTextLayer.innerHTML = targetItem.intro_proc || targetItem.intro;

				this.checkTooltipIFrames(this.tooltipTextLayer.innerHTML);
				this.tooltipLayer.style.display = 'block';
				this.tooltipLayer.setAttribute('id', 'dpintro-tooltip-step-' + targetItem.step);

				//change active bullet
				if (this._options.showBullets) {
					this.activateBullet(this.tooltipReferenceLayer, LAYER_CLASSES.bullets, targetItem.step);
				}

				const progressVal = this._getProgress();
				this.progressBarLayer.style.cssText = 'width:' + progressVal + '%;';
				this.progressBarLayer.setAttribute('aria-valuenow', progressVal);

				//$(this.highlightLayer).fadeIn(350);

				this.highlightLayer.style.opacity = 1;
				this.highlightLayer.setAttribute('id', `${LAYER_CLASSES.highlight}-step-${targetItem.step}`);
				this.bulletsLayer.style.opacity = 1;
				this._placeTooltip(targetItem, this.highlightLayer, this.tooltipLayer, this.arrowLayer, this.tooltipNumberLayer);

				// change the scroll of the window, if needed
				const scrollOffset = this._getScrollOffset(targetItem.scrollTo, targetItem);
				this._scrollTo(scrollOffset, noAfterEvent);
			}
		}, this._movingTime);


		// removing previous disable interaction layer

		//disable interaction
		if (targetItem.enable_interaction.val != '1' && !targetItem.isDummyElement) {
			this._disableInteraction();
		} else {
			this._enableInteraction();
		}
	}

	checkTooltipIFrames = (innerHTML) => {
		this.tooltipBBRel = DPBoundingBox.getElBoundingBox(this.tooltipTextLayer, false, true);
		if (innerHTML) {
			const start = innerHTML.indexOf('<iframe');
			if (start >= 0) {
				const stop = innerHTML.indexOf('>', start + 7);
				if (stop >= 0) {
					const iframeStr = innerHTML.substr(start, stop - start + 1);
					if (iframeStr && iframeStr.includes('allowfullscreen')) {
						this._isIframeInTooltip = true;
						return;

					}
				}
			}
		}
		this._isIframeInTooltip = false;
	}
	/**
	 * Show an element on the page
	 *
	 * @api private
	 * @method _showElement
	 * @param {Object} targetItem
	 */
	_showElement = (targetItem, noAfterEvent = false, isAutoPosCorrectionRepetition = false, backward = false) => {
		this.emitter.emit(EVENTS.onChange, this, targetItem);
		this.currentFlyingObjectBB = null;
		if (isAutoPosCorrectionRepetition) this._autoPosCorrectionRepetition++;
		else this._autoPosCorrectionRepetition = 0;
		let waitMs = 0;
		if (typeof (this._introBeforeShowStepCallback) !== 'undefined') {
			waitMs = this._introBeforeShowStepCallback(this, targetItem);
		}
		setTimeout(() => {
			this._showElementDelayed(targetItem, noAfterEvent, backward);
		}, waitMs);

	}

	_actualizeNavigation = () => {
		const isLastStep = this.getEndStepIdx() <= this._currentStep;
		const isFirstStep = this._currentStep <= this.getStartStepIdx();
		const hidePrev = this._options.hide_previous_step_button || (this._options.hidePrev && isFirstStep);
		const hideNext = this._options.hideNextAlways || (this._options.hideNext === true && isLastStep);
		const buttonPrevClass = classNames({
			[this._options.buttonClass]: true,
			[LAYER_CLASSES.buttonPrev]: true,
			[LAYER_CLASSES.hiddenByOpacity]: hidePrev,
			[LAYER_CLASSES.disabled]: !hidePrev && isFirstStep,
			[LAYER_CLASSES.buttonFull]: hideNext,
		});
		const buttonNextClass = classNames({
			[this._options.buttonClass]: true,
			[LAYER_CLASSES.buttonNext]: true,
			[LAYER_CLASSES.hiddenByOpacity]: hideNext,
			[LAYER_CLASSES.disabled]: !hideNext && isLastStep,
			[LAYER_CLASSES.buttonFull]: hidePrev
		});
		const buttonSkipClass = classNames({
			[this._options.buttonClass]: true,
			[LAYER_CLASSES.buttonSkip]: true,
			[LAYER_CLASSES.buttonDone]: isLastStep,
			[LAYER_CLASSES.hiddenByOpacity]: this._options.hide_skip_button && !isLastStep,
		});
		const buttonSkipLabel = isLastStep ? this._options.doneLabel : this._options.skipLabel;

		if (isFirstStep && this._introItems.length > 1) this._activeControl = 'next';
		else if (isLastStep) this._activeControl = 'skip';

		if (typeof this.buttonPrevLayer !== 'undefined' && this.buttonPrevLayer !== null) {
			this.buttonPrevLayer.className = buttonPrevClass;
			$(this.buttonPrevLayer).hover(
				() => this.emitter.emit(EVENTS.onButtonHover, 'back', true),
				() => this.emitter.emit(EVENTS.onButtonHover, 'back', false)
			);
		}

		if (typeof this.buttonNextLayer !== 'undefined' && this.buttonNextLayer !== null) {
			this.buttonNextLayer.className = buttonNextClass;
			$(this.buttonNextLayer).hover(
				() => this.emitter.emit(EVENTS.onButtonHover, 'next', true),
				() => this.emitter.emit(EVENTS.onButtonHover, 'next', false)
			);
		}

		if (typeof this.buttonSkipLayer !== 'undefined' && this.buttonSkipLayer !== null) {
			this.buttonSkipLayer.className = buttonSkipClass;
			this.buttonSkipLayer.innerHTML = buttonSkipLabel;
		}

		if (this._options.disable_navigation_by_bullets) $(this.bulletsLayer).addClass(LAYER_CLASSES.bullets + '--pointer-events-none');
		else $(this.bulletsLayer).removeClass(LAYER_CLASSES.bullets + '--pointer-events-none');

		if (this._introItems.length > 1 && this._options.showBullets) $(this.bulletsLayer).slideDown();
		else $(this.bulletsLayer).slideUp();

		this._fixButtonFont();
	}

	_fixTargetLowContrast = (lightBoxBbLayer, targetElement, isSecondTry = false) => {
		// check color of target element to ensure contrast background
		try {
			if (targetElement.isDummyElement) return;
			let adjusted = false;
			let lightBoxBgColorStr = lightBoxBbLayer.style.backgroundColor;
			if (!isSecondTry) {
				lightBoxBgColorStr = `rgb(${this._getCssVarVal(this._wrapperEl, '--highlight-layer-bg-color', '255, 255, 255')})`;
				//console.log('Highlight layer bg: '+ lightBoxBgColorStr);
			}

			if (lightBoxBgColorStr) {
				//console.log('LightboxBg: ' + lightBoxBgColorStr, isSecondTry);
				const lightBoxBgColor = new Color(lightBoxBgColorStr);
				if (lightBoxBgColor) {

					const textChilds = $(targetElement).find(':visible').add(targetElement);
					if (textChilds) {

						let parentOfTargetEl = $(targetElement).parent();
						if (parentOfTargetEl) parentOfTargetEl = parentOfTargetEl[0];
						const _self = this;
						textChilds.each(function () {
							let opacity = 1;
							const opacityStr = $(this).css('opacity');
							if (opacityStr) opacity = Number(opacityStr);

							let beforeOpacity = 1;
							const beforeElStyle = window.getComputedStyle(this, ':before');
							const hasBeforeContent = beforeElStyle.getPropertyValue('content') != 'none';
							if (hasBeforeContent) {
								const beforeOpacityStr = beforeElStyle.getPropertyValue('opacity');
								if (beforeOpacityStr) beforeOpacity = Number(beforeOpacityStr);
							}

							let afterOpacity = 1;
							const afterElStyle = window.getComputedStyle(this, ':after');
							const hasAfterContent = afterElStyle.getPropertyValue('content') != 'none';
							if (hasAfterContent) {
								const afterOpacityStr = afterElStyle.getPropertyValue('opacity');
								if (afterOpacityStr) afterOpacity = Number(afterOpacityStr);
							}
							let isSvg = this.firstChild ? $(this.firstChild).prop('tagName') === 'svg' : false;
							const hasActivePseudoEl = (hasBeforeContent && beforeOpacity > 0) || (hasAfterContent && afterOpacity > 0);

							if (this.firstChild && (this.firstChild.nodeType === Node.TEXT_NODE || isSvg) && opacity > 0 || hasActivePseudoEl) {
								const text = this.textContent;

								let targetColorStr = $(this).css('color');

								if (!text && hasActivePseudoEl) {
									if (hasBeforeContent) targetColorStr = beforeElStyle.getPropertyValue('color');
									else if (hasAfterContent) targetColorStr = afterElStyle.getPropertyValue('color');
								}

								if (targetColorStr) {
									const targetColor = new Color(targetColorStr);
									if (targetColor) {
										// travel up to target element to mix bg
										let finalBg = { r: 0, g: 0, b: 0, a: 0 };
										let elToScannBg = this;

										while (elToScannBg && elToScannBg != parentOfTargetEl) {
											const elBgColorStr = $(elToScannBg).css('background-color');
											if (elBgColorStr) {
												const elBgColor = new Color(elBgColorStr);
												if (elBgColor) {
													if (elBgColor.alpha()) {
														finalBg = normal(colorToRgbaObject(elBgColor), finalBg);
													}
													if (finalBg.a > 0.9) break;
												}
											}
											elToScannBg = $(elToScannBg).parent();
											if (elToScannBg) elToScannBg = elToScannBg[0];
										}

										if (finalBg.a < 0.9) {
											const finalBgColorObj = rgbaObjectToColor(normal(colorToRgbaObject(lightBoxBgColor), finalBg));
											const bgLum = finalBgColorObj.luminosity();
											const targetColorLum = targetColor.luminosity();
											//console.log('Final bg: ' + targetColor.toString(), isSecondTry);
											//console.log('Contrast:', bgLum - targetColorLum);
											const contrast = Math.abs(bgLum - targetColorLum);
											//console.log(`contrast:${contrast}`);
											if (contrast < 0.3) {
												//console.log(`LOW CONTRAST - text:${text.substr(0, 20)} | contrast:${contrast} | bg:${finalBgColorObj} | color:${targetColor}`);
												//console.log('Low contrast');
												if (!isSecondTry) {

													let bgNew;
													if (lightBoxBgColor.isDark()) bgNew = 'rgb(255, 255, 255)';
													else bgNew = 'rgb(34, 34, 34)';
													lightBoxBbLayer.style.backgroundColor = bgNew;
													_self._fixTargetLowContrast(lightBoxBbLayer, targetElement, true);
													adjusted = true;
													return;
												}
												else {
													$(this).addClass('dp-intro-color-adjusted');
													if (!$(this).data('init-color')) $(this).attr('data-init-color', targetColorStr);
													if (lightBoxBgColor.isDark()) {
														$(this).css('color', targetColor.lighten(0.5).rgb().toString());
													}
													else {
														$(this).css('color', targetColor.darken(0.5).rgb().toString());
													}
												}

											}
										}
									}
								}
							}
						});

					}
				}
				if (lightBoxBbLayer.style.backgroundColor && !isSecondTry && !adjusted) {
					this._removeInlineProp(lightBoxBbLayer, 'background-color');
				}
			}
		}
		catch (e) {
			console.warn('Exception thrown in _fixTargetLowContrast', e.stack);
		}

	}

	_removeInlineProp(elem, propName) {
		if (elem.style.removeProperty) {
			elem.style.removeProperty(propName);
		} else {
			elem.style.removeAttribute(propName);
		}
	}

	_bulletClickCallback = (event) => {
		if (event && event.target && !this._options.disable_navigation_by_bullets) { this.goToStep(event.target.getAttribute('data-stepnumber')); }
	}


	_initLayers(targetItem, highlightClass) {

		// Highlight
		this.highlightLayer = document.createElement('div');
		this.highlightLayer.className = highlightClass;
		this.inHighlightLayerAnimation = new BulletsAnimation(
			'.' + highlightClass,
			'in-highlight-bullets-anim',
			[LAYER_CLASSES.bullets, `${LAYER_CLASSES.bullets}--in-highlight`], 3, 100);

		this._mainElement.appendChild(this.highlightLayer);

		// Tooltip ref.
		this.tooltipReferenceLayer = document.createElement('div');
		this.tooltipReferenceLayer.className = LAYER_CLASSES.tooltipReference;
		this._mainElement.appendChild(this.tooltipReferenceLayer);

		// Tooltip
		this.tooltipLayer = document.createElement('div');
		this.tooltipLayer.style.opacity = 0;
		if (this._options.max_tooltip_width && !isNaN(this._options.max_tooltip_width))
			this.tooltipLayer.style.maxWidth = this._options.max_tooltip_width + 'px';
		this.tooltipLayer.className = LAYER_CLASSES.tooltip;
		this.tooltipReferenceLayer.appendChild(this.tooltipLayer);

		// Tooltip text
		this.tooltipTextLayer = document.createElement('div');
		this.tooltipTextLayer.className = LAYER_CLASSES.tooltipText;
		this.tooltipTextLayer.innerHTML = targetItem.intro;
		this.tooltipLayer.appendChild(this.tooltipTextLayer);

		// Tooltip arrow
		this.arrowLayer = document.createElement('div');
		this.arrowLayer.className = LAYER_CLASSES.arrow;
		this.tooltipLayer.appendChild(this.arrowLayer);

		// Progress bar
		this.progressLayer = document.createElement('div');
		this.progressLayer.className = LAYER_CLASSES.progress;
		if (this._options.showProgress === false) {
			this.progressLayer.style.display = 'none';
		}
		this.progressBarLayer = document.createElement('div');
		this.progressBarLayer.className = LAYER_CLASSES.progressBar;
		this.progressBarLayer.setAttribute('role', 'progress');
		this.progressBarLayer.setAttribute('aria-valuemin', 0);
		this.progressBarLayer.setAttribute('aria-valuemax', 100);
		this.progressBarLayer.setAttribute('aria-valuenow', this._getProgress());
		this.progressBarLayer.style.cssText = 'width:' + this._getProgress() + '%;';
		this.progressLayer.appendChild(this.progressBarLayer);
		this.tooltipLayer.appendChild(this.progressLayer);

		// Tooltip bullets
		this.bulletsLayer = this.createBullets(
			LAYER_CLASSES.bullets,
			this._options.showBullets,
			true,
			targetItem.step - 1,
			this._bulletClickCallback
		);
		this.tooltipLayer.appendChild(this.bulletsLayer);

		// Tooltip buttons
		this.tooltipButtonsLayer = document.createElement('div');
		this.tooltipButtonsLayer.className = LAYER_CLASSES.tooltipButtons;
		if (this._options.showButtons === false) {
			this.tooltipButtonsLayer.style.display = 'none';
		}
		this.tooltipLayer.appendChild(this.tooltipButtonsLayer);

		//Tooltip number
		this.tooltipNumberLayer = null;

		this.tooltipNumberLayer = document.createElement('div');
		this.tooltipNumberLayer.style.opacity = 0;
		this.tooltipNumberLayer.className = LAYER_CLASSES.tooltipNumber + ' dpintro-hidden-by-opacity';
		this.tooltipNumberLayer.innerHTML = targetItem.step;
		this.tooltipReferenceLayer.appendChild(this.tooltipNumberLayer);


		if (this._options.showStepNumbers !== true) {
			$(this.tooltipNumberLayer).addClass('dpintro-hidden-by-opacity');
		}

		//next button
		this.buttonNextLayer = document.createElement('div');
		this.buttonNextLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonNext].join(' ');
		this.buttonNextLayer.onclick = this.goToNextStep.bind(this);
		this._setAnchorAsButton(this.buttonNextLayer);
		this.buttonNextLayer.innerHTML = this._options.nextLabel;

		//previous button
		this.buttonPrevLayer = document.createElement('div');
		this.buttonPrevLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonPrev].join(' ');
		this.buttonPrevLayer.onclick = this.goToPreviousStep.bind(this);
		this._setAnchorAsButton(this.buttonPrevLayer);
		this.buttonPrevLayer.innerHTML = this._options.prevLabel;

		//skip button

		this.buttonSkipLayer = document.createElement('div');
		this.buttonSkipLayer.className = [LAYER_CLASSES.button, LAYER_CLASSES.buttonSkip].join(' ');
		this._setAnchorAsButton(this.buttonSkipLayer);
		this.buttonSkipLayer.innerHTML = this._options.skipLabel;
		this.buttonSkipLayer.onclick = () => {
			this.onSkipButtonClick();
		};
		this.tooltipButtonsLayer.appendChild(this.buttonSkipLayer);


		//in order to prevent displaying next/previous button always
		if (this._introItems.length >= 1) {
			this.tooltipButtonsLayer.appendChild(this.buttonPrevLayer);
			this.tooltipButtonsLayer.appendChild(this.buttonNextLayer);
		}

		this.refreshStepNumber();

		// on layer init event
		this.emitter.emit(EVENTS.onLayersInit, this);
	}

	onSkipButtonClick() {
		this._exitIntro('skip');
	}

	refreshStepNumber() {
		if (this._options.showStepNumbers === true && this._introItems.length > 1) {
			$(this.tooltipNumberLayer).removeClass('dpintro-hidden-by-opacity');
		}
		else {
			$(this.tooltipNumberLayer).addClass('dpintro-hidden-by-opacity');
		}
	}

	goToPreviousStep() {
		if (this._currentStep !== 0) {
			this.previousStep();
			return true;
		}
		return false;
	}

	goToNextStep() {
		if (this._introItems.length - 1 !== this._currentStep) {
			this.nextStep();
			return true;
		}
		return false;
	}


	_fixButtonFont() {
		const buttons = $('.' + this._options.buttonClass);
		if (buttons && buttons.length) {
			const ff = buttons.css('font-family');
			if (ff && ff.startsWith('"Martel Sans"')) {
				buttons.addClass(`${this._options.buttonClass}--higher-top-padding`);
			}
			else {
				buttons.removeClass(`${this._options.buttonClass}--higher-top-padding`);
			}
		}
	}

	_getFixedTooltipOffset = () => {
		if (this.isFixedTooltipBottomTheme()) {
			const tooltipEl = $(this.tooltipLayer);
			if (tooltipEl) {
				if (tooltipEl.hasClass(`${LAYER_CLASSES.tooltip}--on-top`)) {
					return { top: tooltipEl.outerHeight(), bottom: 0 };
				}
				else {
					let top = 0;
					const jBulletsEl = $(this.bulletsLayer);
					if (jBulletsEl && jBulletsEl.length) {
						let bulletsTop = parseFloat(jBulletsEl.css('top'));
						if (isNaN(bulletsTop)) bulletsTop = 0;
						const bulletsHeight = jBulletsEl.outerHeight();
						top = bulletsTop + bulletsHeight;
					}
					return { top: top, bottom: tooltipEl.outerHeight() };
				}
			}
		}
		return { top: 0, bottom: 0 };
	}


	_getFlyingObjectsBB = (targetBB, tooltipBB, numberBB) => {
		var rect;

		if (this.isFixedTooltipBottomTheme()) {
			rect = targetBB;
		}
		else if (scrollTo === 'element') {
			rect = DPBoundingBox.mergeBoundingBoxes(targetBB, numberBB);
		}
		else if (scrollTo === 'tooltip') {
			rect = tooltipBB;
		}
		else {
			rect = DPBoundingBox.mergeBoundingBoxes(targetBB, tooltipBB, numberBB);
		}
		return rect;
	}

	getBottomScrollOffset(flyingObjectsBB, targetBB, tooltipBB, winHeight, fixedTooltipOffset, isFixedOnTop) {
		const isFixedTooltipBottomTheme = this.isFixedTooltipBottomTheme();
		let scrollOffsetY = flyingObjectsBB.top - ((winHeight / 2) - (flyingObjectsBB.height / 2));
		if (!isFixedTooltipBottomTheme && flyingObjectsBB.height - 10 > winHeight) {
			if (tooltipBB.top > targetBB.bottom) {
				scrollOffsetY = flyingObjectsBB.bottom - winHeight + 20;
			}
			else if (tooltipBB.bottom < targetBB.top) {
				scrollOffsetY = flyingObjectsBB.top - 20;
			}
		}
		if (isFixedTooltipBottomTheme) {
			scrollOffsetY -= fixedTooltipOffset.top;
		}
		if (isFixedOnTop) {
			scrollOffsetY -= fixedTooltipOffset.bottom;
		}
		return scrollOffsetY;
	}


	_getScrollOffset = (scrollTo, targetItem) => {
		if (scrollTo !== 'off' && this._options.scrollToElement && !targetItem.isDummyElement && !targetItem.isFixedPosition) {

			const targetElement = targetItem.element;
			const winSize = this._getWinSize();
			const fixedTooltipOffset = this._getFixedTooltipOffset();
			const winHeight = winSize.height - (fixedTooltipOffset.top + fixedTooltipOffset.bottom);

			const targetBB = DPBoundingBox.getElBoundingBox(targetElement);

			const tooltipBB = DPBoundingBox.getElBoundingBox(this.tooltipLayer);

			const numberBB = this._options.showStepNumbers === true ? DPBoundingBox.getElBoundingBox(this.tooltipNumberLayer) : null;

			this.currentFlyingObjectBB = this._getFlyingObjectsBB(targetBB, tooltipBB, numberBB);


			const isFixedTooltipBottomTheme = this.isFixedTooltipBottomTheme();

			if (isFixedTooltipBottomTheme) {
				if (this.bulletsLayer) {
					$(this.bulletsLayer).removeClass('dpintro-bullets--hidden');
					if (!targetItem.isDummyElement) {
						const bulletsBB = DPBoundingBox.getElBoundingBox(this.bulletsLayer);
						if (this.currentFlyingObjectBB.top < bulletsBB.bottom + 10) {
							$(this.bulletsLayer).addClass('dpintro-bullets--hidden');
						}
					}
				}
			}


			let scrollOffsetY = this.getBottomScrollOffset(this.currentFlyingObjectBB, targetBB, tooltipBB, winHeight, fixedTooltipOffset, $(this.tooltipLayer).hasClass(`${LAYER_CLASSES.tooltip}--on-top`));

			let scrollOffsetX = this.currentFlyingObjectBB.left - ((winSize.width / 2) - (this.currentFlyingObjectBB.width / 2));
			if (this.currentFlyingObjectBB.width - 10 > winSize.width) {
				if (tooltipBB.left > targetBB.right) {
					scrollOffsetX = this.currentFlyingObjectBB.right - winSize.width + 20;
				}
				else if (tooltipBB.right < targetBB.left) {
					scrollOffsetX = this.currentFlyingObjectBB.left - 20;
				}
			}

			// saturate to document height and width
			const maxLeft = $(document).width() - winSize.width;
			const maxTop = $(document).height() - winSize.height;
			return {
				x: Math.max(0, Math.min(scrollOffsetX, maxLeft)),
				y: Math.max(0, Math.min(scrollOffsetY, maxTop))
			};
		}
		return null;
	}

	/**
	 * To change the scroll of `window` after highlighting an element
	 *
	 * @api private
	 * @method _scrollTo
	 * @param {String} scrollTo
	 * @param {Object} targetElement
	 * @param {Object} tooltipLayer
	 */
	_scrollTo = (scrollOffset, noAfterEvent = false) => {
		if (scrollOffset) {

			$('html').animate(
				{ scrollLeft: scrollOffset.x, scrollTop: scrollOffset.y },
				this._options.scrollDurationMsOverride >= 0 ? this._options.scrollDurationMsOverride : this._calculateScrollTimeToTargetEl(scrollOffset),
				this._options.scrollEasing,
				() => { this._afterScrollOnNewElement(noAfterEvent); }
			);
		}
		else {
			this._afterScrollOnNewElement(noAfterEvent);
		}
	}

	_calculateScrollTimeToTargetEl(targetOffset) {

		const winSize = this._getWinSize();
		const startOffset = { left: $(window).scrollLeft(), top: $(window).scrollTop() };
		const dist = Math.max(Math.abs(startOffset.left - targetOffset.x), Math.abs(startOffset.top - targetOffset.y));
		const res = Math.round(Math.min(this._options.maxScrollSpeedPerPageMs, Math.max(350, (dist / winSize.height) * this._options.scrollSpeedPerPageMs)));
		/*console.log({
			'Scroll time': res,
			maxScrollSpeedPerPageMs: this._options.maxScrollSpeedPerPageMs,
			scrollSpeedPerPageMs: this._options.scrollSpeedPerPageMs
		});*/
		return res;
	}

	/* _calculateMovingTimeToTargetEl(targetItem){
 
		 if (targetItem.isDummyElement) return 350;
		 const targetElOffset = $(targetItem.element).offset();
		 const winSize = this._getWinSize();
		 const startOffset = this._lastShownItem && !this._lastShownItem.isDummyElement && this._lastShownItem.element
		  ? $(this._lastShownItem.element).offset()
		  : { left: $(window).scrollLeft(), top: $(window).scrollTop() };
		 const dist = Math.sqrt( Math.pow(targetElOffset.left -  startOffset.left, 2) +  Math.pow(targetElOffset.top -  startOffset.top, 2));
		 // 350 - minimum for css animation to process
		 const res = Math.max(350, (dist / winSize.height) * this._options.scrollSpeedPerPageMs); 
		 return Math.round(res);
	 }*/

	_checkTargetPosition(targetItem, noAfterEvent) {
		let res = true;
		if (this._autoPosCorrectionRepetition < 3 && !this._trackingTargetInProgress) {
			const isMobileSize = this._isMobileSize();
			let shouldBeSkiped = this._shouldBeStepSkipped(targetItem, isMobileSize);
			if (shouldBeSkiped) {
				this._showElement(this._introItems[this._currentStep], noAfterEvent, true, false);
				res = false;
			}
			else {
				// first check - right scroll
				let checkScroll = this._checkTargetPositionScroll(targetItem);
				let checkBBRatio = this._checkTargetPositionBBRatio(targetItem);

				res = checkScroll && checkBBRatio;
				if (!res) {
					if (this.currentFlyingObjectBB) {
						const winSize = this._getWinSize();
						const introElementsBox = DPBoundingBox.boundingBox2RelativeScrollPos(this.currentFlyingObjectBB);
						if (introElementsBox.top >= 0 && introElementsBox.left >= 0 && introElementsBox.bottom < winSize.height && introElementsBox.right < winSize.width) {
							if (!checkScroll && checkBBRatio) return true;
							else {
								this._setLayerPosition(this.highlightLayer);
								this._setLayerPosition(this.tooltipReferenceLayer);
								this._placeTooltip(targetItem, this.highlightLayer, this.tooltipLayer, this.arrowLayer, this.tooltipNumberLayer);
								return true;
							}

						}
					}
					this._showElement(this._introItems[this._currentStep], noAfterEvent, true, false);
				}
			}
		}
		return res;
	}

	_checkTargetPositionBBRatio(targetItem) {

		if (!targetItem.isDummyElement) {
			const targetBBRaw = DPBoundingBox.getElBoundingBox(targetItem.element, true);
			const lithBoxBgPadding = this._options.helperElementPadding / 2;
			var targetBB = DPBoundingBox.actualizeHeightAndWidthInBoundingBox({
				top: Math.max(targetBBRaw.top - lithBoxBgPadding, 0),
				left: Math.max(targetBBRaw.left - lithBoxBgPadding, 0),
				bottom: Math.min(targetBBRaw.bottom + lithBoxBgPadding, $(document).innerHeight()),
				right: Math.min(targetBBRaw.right + lithBoxBgPadding, $(window).innerWidth()),
			});
			const highlightBB = DPBoundingBox.getElBoundingBox(this.highlightLayer, true);
			const intersectBB = DPBoundingBox.intersectBoundingBoxes(targetBB, highlightBB);
			const targetBBArea = targetBB.height * targetBB.width;
			const intersectBBArea = intersectBB.height * intersectBB.width;
			const ratio = intersectBBArea / targetBBArea;
			if (ratio < 0.9) {
				return false;
			}
		}
		return true;
	}

	_checkTargetPositionScroll(targetItem) {

		const scrollOffset = this._getScrollOffset(targetItem.scrollTo, targetItem);
		// first check - right scroll
		if (scrollOffset) {

			const scrollXDiff = Math.abs($(window).scrollLeft() - scrollOffset.x);
			const scrollYDiff = Math.abs($(window).scrollTop() - scrollOffset.y);

			//console.log(`xoffsetdiff:${scrollXDiff} yoffsetdiff:${scrollYDiff}`);
			if (scrollXDiff > 10 || scrollYDiff > 10) {
				return false;
			}
		}

		return true;
	}

	_afterScrollOnNewElement = (noAfterEvent = false) => {
		//console.log('scroll ended');
		if (this.tooltipReferenceLayer && !this.ending) {


			// is scrolled to element - check due moving tergeted element by animations
			const targetItem = this._introItems[this._currentStep];

			this._lastShownItem = targetItem;
			if (!this._checkTargetPosition(targetItem, noAfterEvent)) return;

			// is correctly scrolled to target element
			$(this.overlayLayer).css('opacity', this._options.overlayOpacity);
			if (this.tooltipNumberLayer) this.tooltipNumberLayer.style.opacity = 1;
			this.tooltipLayer.style.opacity = 1;
			//show the tooltip
			const isFixedTooltipTheme = this.isFixedTooltipBottomTheme();
			if (isFixedTooltipTheme) {
				this._removeClass(this.tooltipLayer, 'hidden');
				//if (this._options.showBullets) $(this.bulletsLayer).slideDown(700);
			}
			else {
				//if (this._options.showBullets) $(this.bulletsLayer).fadeIn(300);
			}

			if (this._options.controlsAutoFocusEnable) {
				let control = null;
				switch (this._activeControl) {
					case 'next': control = this.buttonNextLayer; break;
					case 'back': control = this.buttonPrevLayer; break;
					case 'skip': control = this.buttonSkipLayer; break;
				}
				control?.focus();
			}

			const isOnTop = $(this._mainElement).hasClass(`${LAYER_CLASSES.main}--on-top`);
			this.emitter.emit(EVENTS.onAfterChange, this, targetItem, {
				isFixedTooltipTheme: isFixedTooltipTheme,
				isFixedTooltipOnTop: isOnTop && isFixedTooltipTheme
			});
			if (!this._options.disableDelayedAfterCheckPosition) {
				setTimeout(() => {
					this._checkTargetPosition(targetItem, noAfterEvent);
				}, 300); //just for init step on current page
			}
		}


	}

	_clearContrastAdjustment() {
		$('.dp-intro-color-adjusted').each((idx, val) => {
			$(val).css('color', $(val).data('init-color'));
			$(val).removeClass('dp-intro-color-adjusted');
		});
	}

	/**
	 * To remove all show element(s)
	 *
	 * @api private
	 * @method _removeShowElement
	 */
	_removeShowElement = () => {
		this._removePossiblyChangingPositionClassSafe('dpintro-fix-parent', 'fix-parent', 'dpintro-fixed-position');
		//this._removePossiblyChangingPositionClassSafe('dpintro-fix-parent-display', 'fix-parent-display');
		this._removePossiblyChangingPositionClassSafe('dpintro-relative-position', 'rel-pos');
		this._resetInlineStyle();

		$('.dpintro-show-el-admin-menu').removeClass('dpintro-show-el-admin-menu');

		var elms = document.querySelectorAll('.dpintro-show-element');
		this._forEach(elms, (elm) => {
			const isDummy = elm === this.dummyElement;
			if (elm.className && typeof elm.className === 'string') {
				const classes = elm.className && elm.className.split(/\s+/);
				if (classes && classes.length) {
					classes.forEach((className) => {
						if (className.startsWith('dpintro-')) {
							$(elm).removeClass(className);
						}
					});
				}
			}
			if (isDummy) $(elm).addClass('dpintro-dummyelement');
		});

	}

	/**
	 * To set the show element
	 * This function set a relative (in most cases) position and changes the z-index
	 *
	 * @api private
	 * @method _setShowElement
	 * @param {Object} targetElement
	 */
	_setShowElement = (targetElement) => {
		var parentElm;

		if (targetElement === this.dummyElement) return;
		// we need to add this show element class to the parent of SVG elements
		// because the SVG elements can't have independent z-index

		/*const jMenuEl = $(targetElement).closest('.menu-top');
		if (jMenuEl.length && jMenuEl.closest('#adminmenu').length) {
			jMenuEl.addClass('dpintro-show-el-admin-menu');
			//return;
		}*/

		if (targetElement instanceof SVGElement) {
			parentElm = targetElement.parentNode;

			while (targetElement.parentNode !== null) {
				if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

				if (parentElm.tagName.toLowerCase() === 'svg') {
					this._addClass(parentElm, 'dpintro-show-element');
					this._addPossiblyChangingPositionClassSafe($(parentElm), 'dpintro-relative-position', 'rel-pos');
				}

				parentElm = parentElm.parentNode;
			}
		}

		this._addClass(targetElement, 'dpintro-show-element');

		var currentElementPosition = this._getPropValue(targetElement, 'position');
		if (currentElementPosition !== 'absolute' &&
			currentElementPosition !== 'relative' &&
			currentElementPosition !== 'fixed') {
			//change to new intro item
			this._addPossiblyChangingPositionClassSafe($(targetElement), 'dpintro-relative-position', 'rel-pos');
		}

		parentElm = targetElement.parentNode;
		var hasFixedOrAbsParent = false;
		var lastFixedParent = null;
		while (parentElm !== null) {
			if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;

			//fix The Stacking Context problem.
			//More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
			var zIndex = this._getPropValue(parentElm, 'z-index');
			var opacity = parseFloat(this._getPropValue(parentElm, 'opacity'));
			var filter = this._getPropValue(parentElm, 'filter');

			var transform = this._getPropValue(parentElm, 'transform') || this._getPropValue(parentElm, '-webkit-transform') || this._getPropValue(parentElm, '-moz-transform') || this._getPropValue(parentElm, '-ms-transform') || this._getPropValue(parentElm, '-o-transform');
			if (/[0-9]+/.test(zIndex) || opacity < 1 || filter || (transform !== 'none' && transform !== undefined)) {
				//this._fixParent(parentElm);
				const fixClasses = ['dpintro-fix-parent'];
				const cssPosition = this._getPropValue(parentElm, 'position');
				if (cssPosition === 'fixed') {
					fixClasses.push('dpintro-fixed-position');
					//this.adjustParentPositionedFixed($(parentElm));
					//this._setInlineStyle(parentElm, { ['z-index']: '9999999 !important'});
				}
				if (cssPosition === 'fixed' || cssPosition === 'absolute') {
					hasFixedOrAbsParent = true;
					lastFixedParent = parentElm;
				}
				this._addPossiblyChangingPositionClassSafe($(parentElm), fixClasses.join(' '), 'fix-parent');
			}
			parentElm = parentElm.parentNode;
		}
		if (hasFixedOrAbsParent) {
			$(this.highlightLayer).addClass(`${LAYER_CLASSES.highlight}--fixed-pos`);
			// set all parents down to the dpintro-fixed-position
			if (lastFixedParent) {
				$(lastFixedParent).find('.dpintro-fix-parent').addClass('dpintro-fixed-position');
			}

		}
		else {
			$(this.highlightLayer).removeClass(`${LAYER_CLASSES.highlight}--fixed-pos`);
		}
	}


	_setInlineStyle(element, css) {
		if (element) {

			$(element).addClass('dpintro-inline-style-adjusted');
			if (element.style.cssText) element.setAttribute('data-style-bkp', element.style.cssText);
			Object.keys(css).forEach(key => {
				if (element.style.cssText && element.style.cssText[element.style.cssText.length - 1] != ';') element.style.cssText += ';';
				element.style.cssText += `${key}:${css[key]};`;
			});
		}
	}

	_resetInlineStyle() {

		$('.dpintro-inline-style-adjusted').each((index, element) => {
			const styleText = $(element).data('style-bkp');
			element.style.cssText = styleText || '';
			$(element).removeClass('dpintro-inline-style-adjusted');
		});



	}

	_addPossiblyChangingPositionClassSafe = (jElement, className, typePrefix = 'fix') => {
		if (jElement.length) {
			const oldIsFollowTargetPositionEnabled = this.isFollowTargetPositionEnabled;
			this.isFollowTargetPositionEnabled = false;
			const element = jElement[0];
			const beforeOffset = jElement.offset();

			jElement.addClass(className);

			const afterOffset = jElement.offset();

			let setOffset = false;
			if (Math.abs(afterOffset.top - beforeOffset.top) > 1) {
				jElement.attr(`data-${typePrefix}-inline-top`, element.style.top);
				setOffset = true;
				//jElement.css('top',beforeOffset.top);
			}

			if (Math.abs(afterOffset.left - beforeOffset.left) > 1) {
				jElement.attr(`data-${typePrefix}-inline-left`, element.style.left);
				setOffset = true;
				//jElement.css('left',beforeOffset.left);
			}
			if (setOffset) {
				jElement.attr(`data-${typePrefix}-inline-position`, element.style.position);
				jElement.offset(beforeOffset);
			}
			this.isFollowTargetPositionEnabled = oldIsFollowTargetPositionEnabled;
		}
	}

	_restoreInlineStyleAfterAddingPossiblyChangingPositionClass = (element, typePrefix, stylePropName) => {
		const attrName = `data-${typePrefix}-inline-${stylePropName}`;
		if (element.hasAttribute(attrName)) {
			const oldIsFollowTargetPositionEnabled = this.isFollowTargetPositionEnabled;
			this.isFollowTargetPositionEnabled = false;
			$(element).css(stylePropName, element.getAttribute(attrName));
			element.removeAttribute(attrName);
			this.isFollowTargetPositionEnabled = oldIsFollowTargetPositionEnabled;
		}
	}

	_removePossiblyChangingPositionClassSafe = (className, typePrefix = 'fix', extraClassToRemove = '') => {
		const oldIsFollowTargetPositionEnabled = this.isFollowTargetPositionEnabled;
		this.isFollowTargetPositionEnabled = false;
		var fixedElements = document.querySelectorAll('.' + className);
		this._forEach(fixedElements, (element) => {
			this._removeClass(element, className);
			if (extraClassToRemove) this._removeClass(element, extraClassToRemove);
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'left');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'top');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'width');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'height');
			this._restoreInlineStyleAfterAddingPossiblyChangingPositionClass(element, typePrefix, 'position');
		});
		this.isFollowTargetPositionEnabled = oldIsFollowTargetPositionEnabled;
	}

	/**
	* Iterates arrays
	*
	* @param {Array} arr
	* @param {Function} forEachFnc
	* @param {Function} completeFnc
	* @return {Null}
	*/
	_forEach = (arr, forEachFnc, completeFnc) => {
		// in case arr is an empty query selector node list
		if (arr) {
			for (var i = 0, len = arr.length; i < len; i++) {
				forEachFnc(arr[i], i);
			}
		}

		if (typeof (completeFnc) === 'function') {
			completeFnc();
		}
	}

	/**
	 * Append a class to an element
	 *
	 * @api private
	 * @method _addClass
	 * @param {Object} element
	 * @param {String} className
	 * @returns null
	 */
	_addClass = (element, className) => {
		if (element) {
			if (element instanceof SVGElement) {
				// svg
				var pre = element.getAttribute('class') || '';

				element.setAttribute('class', pre + ' ' + className);
			} else {
				if (element.classList !== undefined) {
					// check for modern classList property
					var classes = className.split(' ');

					this._forEach(classes, (cls) => {
						element.classList.add(cls);
					});
				} else if (!element.className.match(className)) {
					// check if element doesn't already have className
					element.className += ' ' + className;
				}
			}
		}
	}

	/**
	 * Remove a class from an element
	 *
	 * @api private
	 * @method _removeClass
	 * @param {Object} element
	 * @param {RegExp|String} classNameRegex can be regex or string
	 * @returns null
	 */
	_removeClass = (element, classNameRegex) => {
		if (element instanceof SVGElement) {
			var pre = element.getAttribute('class') || '';

			element.setAttribute('class', pre.replace(classNameRegex, '').replace(/^\s+|\s+$/g, ''));
		} else {
			element.className = element.className.replace(classNameRegex, '').replace(/^\s+|\s+$/g, '');
		}
	}

	/**
	 * Get an element CSS property on the page
	 * Thanks to JavaScript Kit: http://www.javascriptkit.com/dhtmltutors/dhtmlcascade4.shtml
	 *
	 * @api private
	 * @method _getPropValue
	 * @param {Object} element
	 * @param {String} propName
	 * @returns Element's property value
	 */
	_getPropValue = (element, propName) => {
		var propValue = '';
		if (element.currentStyle) { //IE
			propValue = element.currentStyle[propName];
		} else if (document.defaultView && document.defaultView.getComputedStyle) { //Others
			propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
		}

		//Prevent exception in IE
		if (propValue && propValue.toLowerCase) {
			return propValue.toLowerCase();
		} else {
			return propValue;
		}
	}

	/**
	 * Checks to see if target element (or parents) position is fixed or not
	 *
	 * @api private
	 * @method _isFixed
	 * @param {Object} element
	 * @returns Boolean
	 */
	_isFixed = (element) => {
		var p = element.parentNode;

		if (!p || p.nodeName === 'HTML') {
			return false;
		}

		if (this._getPropValue(element, 'position') === 'fixed') {
			return true;
		}

		return this._isFixed(p);
	}

	/**
	 *
	 * @api private
	 * @method _getWinSize
	 * @returns {Object} width and height attributes
	 */
	_getWinSize = () => {
		const body = $('body');
		if (body) {
			return { width: body.innerWidth(), height: window.innerHeight };
		}
		else if (window.innerWidth !== undefined) {
			return { width: window.innerWidth, height: window.innerHeight };
		} else {
			var D = document.documentElement;
			return { width: D.clientWidth, height: D.clientHeight };
		}
	}

	/**
	 * Add overlay layer to the page
	 *
	 * @api private
	 * @method _addOverlayLayer
	 */
	// targetElm can be body
	addOverlayLayer = (hidden = false, blurred = false) => {

		if (!this._mainElement.querySelector('.' + LAYER_CLASSES.overlay)) {

			this.overlayContainer = document.createElement('div');
			this.overlayContainer.className = blurred
				? LAYER_CLASSES.overlayContainer + ' ' + LAYER_CLASSES.overlayContainer + LAYER_CLASSES.overlayBlurredModifier
				: LAYER_CLASSES.overlayContainer;

			this.overlayLayer = document.createElement('div');
			this.overlayLayer.className = blurred
				? LAYER_CLASSES.overlay + ' ' + LAYER_CLASSES.overlay + LAYER_CLASSES.overlayBlurredModifier
				: LAYER_CLASSES.overlay;
			this.overlayContainer.appendChild(this.overlayLayer);
			this._mainElement.appendChild(this.overlayContainer);
			if (!hidden) {
				window.setTimeout(() => {
					this.overlayLayer.style.cssText = 'opacity: ' + this._options.overlayOpacity.toString() + ';';
				}, 10);
			}

		}
		return true;
	}

	/**
	* Find the nearest scrollable parent
	* copied from https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
	*
	* @param Element element
	* @return Element
	*/
	_getScrollParent = (element) => {
		var style = window.getComputedStyle(element);
		var excludeStaticParent = (style.position === 'absolute');
		var overflowRegex = /(auto|scroll)/;

		if (style.position === 'fixed') return document.body;

		for (var parent = element; (parent = parent.parentElement);) {
			style = window.getComputedStyle(parent);
			if (excludeStaticParent && style.position === 'static') {
				continue;
			}
			if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
				//console.log('_getScrollParent', parent, style.position, style.overflow, style.overflowY, style.overflowX);
				return parent;
			}
		}

		return document.body;
	}

	/**
	* scroll a scrollable element to a child element
	*
	* @param Element parent
	* @param Element element
	* @return Null
	*/
	_scrollParentToElement = (parent, element) => {

		let parentPos = parent.getBoundingClientRect();
		let childPos = element.getBoundingClientRect();

		if (childPos.top - 40 < parentPos.top || childPos.bottom + 40 > parentPos.bottom) parent.scrollTop += childPos.top - 40;
		if (childPos.left - 40 < parentPos.left || childPos.right + 40 > parentPos.right) parent.scrollLeft += childPos.left - 40;

		if (this._options.dpDebugEn) console.log('Scrolling inside parent container:', {
			parentPos: parentPos,
			childPos: childPos,
		});

	}

	/**
	 * Gets the current progress percentage
	 *
	 * @api private
	 * @method _getProgress
	 * @returns current progress percentage
	 */
	_getProgress = () => {
		// Steps are 0 indexed
		var currentStep = parseInt((this._currentStep + 1), 10);
		return ((currentStep / (this._introItems.length - this.getNotVisibleStepCnt(LAYER_CLASSES.bullets))) * 100);
	}

}
